import query from "devextreme/data/query";
import Form, {
    Label, SimpleItem, GroupItem, RequiredRule, TabbedItem, TabPanelOptions, Tab
} from '../../components/BootstrapForm';
import { Popup, Position, ScrollView, Button, CheckBox } from '../../components/BootstrapControls';
import DataGrid, {
    Column, Scrolling, Selection, LoadPanel, FilterRow, Grouping, GroupPanel
} from '../../components/BootstrapDataGrid';
import { Redirect } from "react-router-dom";
import Axios from "../../api/axios";
import notify from '../../utils/notifyUtil';
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import Dict from "../../messages.js";
import * as glb from "../../globals.js";
import * as utl from "../../utils/utils.js";
import { getSelectableUsersWithIncluded } from "../../utils/userLookup.js";
import { ensureEntityBundleCached, loadLocalCariBundle, peekLocalCariBundle, refreshCariBundle } from "../../services/syncService";
import { trackRecentEntity } from "../../utils/recentEntities";
import { getCached, getCachedOrFetch, clearCached, cariRecCacheKey, carRefCacheKey } from "../../utils/requestCache.js";
import { emitCariSync, subscribeCariSync } from "../../utils/cariSyncBus.js";
import CariYazdir from "../../components/cari/YazdirPanel.js";
import CariAra from "../../components/cari/CariBulPanel.js";
import CariAramaPanel from "../../components/cari/CariAramaPanel.js";
import Carisatis from './carisatis.js';
import IslemGirPanel from './IslemGirPanel.js';
import ResimGirPanel from './ResimGirPanel.js';
import ParaGirPanel from './ParaGirPanel.js';
import EkimKanalAlimGirPanel from './EkimKanalAlimGirPanel.js';
import WhatsAppConversationsPanel from './WhatsAppConversationsPanel.js';
import { cariKayitliMi } from '../../components/cari/MasterKayitGerekliUyari.js';
import { addMaxLengthToEditorOptions,addMaxLengthToGridColumn } from '../../utils/formValidationHelper.js';
import cariModelStore from '../../store/cariModelStore';
import { syncCarikart } from '../../utils/cariSyncEngine';
import { nextTempCarRef, isTempId } from '../../utils/tempIdUtils';
import { useTabNavigation } from '../../contexts/tab-navigation';
import { canDeleteByOwner, cariDataSahibiRef, FOREIGN_DELETE_MESSAGE } from '../../utils/ownRecordDelete.js';
import LegacyCariDfm from '../LEGACY_CARI_DFM/LegacyCariDfm';
import { QuickDateOnlyBox, QuickDateTimeBox } from '../../components/common/QuickDateBoxes';
import { enableGridWheelOuterScroll } from '../../utils/gridWheelOuterScroll.js';
import { attachFormEnterToNextField } from '../../utils/formEnterFocusNext';
import { MESLEK_EVENT, refreshGlobalMeslekLkp } from '../../utils/meslekLkp.js';
import { gridHeightByRowCount, gridMaxHeightForRows } from '../../utils/gridAutoHeight.js';
import './carikart.css';

/** Form cevapları / gelişler: satıra göre büyür; tab paneli grid yüksekliğini takip eder. */
const FORM_CEVAP_GRID_H_OPTS = { rowH: 34, headerH: 40, pad: 8 };
const FORM_CEVAP_GRID_MAX_H = gridMaxHeightForRows(12, FORM_CEVAP_GRID_H_OPTS);
const FORM_TAB_CHROME_H = 46;
const FORM_GELIS_LABEL_H = 32;

function formCevapGroupKey(row) {
    const g = row?.CFG_GELIS_NO;
    if (g != null && g !== '') return g;
    return row?.CFG_GELIS_LABEL ?? 0;
}

function formCevapVisibleRowCount(rows, collapsedKeys) {
    const list = Array.isArray(rows) ? rows : [];
    if (!list.length) return 1;
    const groups = new Set(list.map(formCevapGroupKey));
    let visibleData = 0;
    groups.forEach((key) => {
        if (collapsedKeys?.has(key)) return;
        visibleData += list.filter((r) => formCevapGroupKey(r) === key).length;
    });
    return groups.size + visibleData;
}

function reklamGorseliUrl(gelis) {
    return gelis?.CFG_AD_IMAGE_URL || gelis?.CFG_AD_THUMBNAIL_URL || '';
}

const USE_CARI_MODEL_STORE = true;

/** Yeni / geçici caride dil alanı boşsa SABIT (ST_TUR=23) içinden Türkçe ST_REF ata. */
function normalizeDtCheckboxFields(fd) {
    if (!fd) return fd;
    const out = { ...fd };
    for (let i = 1; i <= 15; i += 1) {
        const key = `DT${String(i).padStart(2, '0')}`;
        if (!(key in out)) continue;
        const v = out[key];
        out[key] = v === true || v === 1 || v === '1'
            || (typeof v === 'string' && (v.toLowerCase() === 'true' || v.toUpperCase() === 'X'));
    }
    return out;
}

function ensureNewCariTrDil(fd) {
    if (!fd) return fd;
    let out = normalizeDtCheckboxFields(fd);
    if (cariKayitliMi(out.CAR_REF)) return out;
    if (out.CAR_DIL_REF != null && out.CAR_DIL_REF !== undefined) return out;
    const diller = query(glb.default.sabitLkp).filter((x) => x.ST_TUR === 23).toArray();
    const tr = diller.find(
        (x) => String(x.ST_KODSTR || '').toLowerCase() === 'tr' || /^türk/i.test(String(x.ST_AD || ''))
    );
    if (!tr) return out;
    return { ...out, CAR_DIL_REF: tr.ST_REF };
}

/** Delphi cari_kart.pas CARIBeforePost — genel yetkili mi? */
function isCariGeneralAuthUser() {
    return Number(glb.default?.KULLANICI?.KUL_YETKI) === 0
        || Number(glb.default?.KULLANICI?.KUL_YS) === 0
        || !!glb.default?.KULLANICI?.KUL_ISADMIN;
}

function getCariOwnerUserRef(fd) {
    const formDataObj = fd || {};
    const owner = Number(formDataObj.CAR_ARA_KUL_REF ?? formDataObj.car_ara_kul_ref ?? 0);
    return Number.isFinite(owner) && owner > 0 ? owner : Number(formDataObj.CAR_GIR_KUL_REF ?? formDataObj.car_gir_kul_ref ?? 0);
}

function isCariOwnerLockedField(fieldName, fd) {
    if (!fieldName || isCariGeneralAuthUser()) return false;
    const currentUser = Number(glb.default?.KULLANICI?.KUL_REF || 0);
    const ownerUser = getCariOwnerUserRef(fd);
    if (!currentUser || !ownerUser || currentUser === ownerUser) return false;
    if (Number(fd?.CAR_REF || 0) <= 0) return false;
    return [
        'CAR_ARA_KUL_REF',
        'CAR_ULASIM_REF',
        'CAR_BULUSMA_REF',
        'CAR_ACENTA_REF',
        'CAR_REF_C_REF'
    ].includes(fieldName);
}

/** Delphi rakam_duzlet + Telefon 11 karakter kuralı (GSM1/GSM2). */
function cariPhoneDigitsForValidation(fd) {
    const digits = (p) => String(p || '').replace(/\D/g, '');
    const a = digits(fd?.CAR_TEL1);
    const b = digits(fd?.CAR_GSM);
    let phone = a.length >= b.length ? a : b;
    if (phone.length > 11) phone = phone.slice(-11);
    return phone;
}

/** Ad karşılaştırmasında harf büyüklüğü, aksan, noktalama ve fazla boşlukları yok sayar. */
function normalizeCariPersonName(value) {
    return String(value || '')
        .toLocaleLowerCase('tr-TR')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/ı/g, 'i')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
}

/** Delphi CARIBeforePost zorunlu alanları. */
function collectDelphiCariKartMissing(fd) {
    const missing = [];
    if (!String(fd?.CAR_ADSOY || '').trim()) missing.push('Ad Soyad');
    const phone = cariPhoneDigitsForValidation(fd);
    if (!phone || phone.length < 11) missing.push('Telefon 11 Karakter Olmalı');
    if (!Number(fd?.CAR_BULUSMA_REF)) missing.push('Ulaşım Şekli');
    if (!Number(fd?.CAR_ULASIM_REF)) missing.push('Proje Adı');
    return missing;
}

function selectedUlasimRequiresReference(fd) {
    const selected = query(glb.default.sabitLkp || [])
        .filter((item) => item.ST_TUR === 1 && Number(item.ST_REF) === Number(fd?.CAR_BULUSMA_REF))
        .toArray()[0];
    const name = String(selected?.ST_AD || '').toLocaleLowerCase('tr-TR');
    return Number(fd?.CAR_BULUSMA_REF) === 431
        || name.includes('referans')
        || name.includes('kuaför')
        || name.includes('kuafor');
}

export default function Carikart(props) {
    const tabNavigation = useTabNavigation();
    // Güvenli ops ve crud
    const ops = props.ops || {};
    const isGeneralYetkiUser = Number(glb.default?.KULLANICI?.KUL_YETKI) === 0
        || Number(glb.default?.KULLANICI?.KUL_YS) === 0
        || !!glb.default?.KULLANICI?.KUL_ISADMIN;
    const safeCrud = {
        ...(ops.crud || {}),
        saveTest: true,
        saveDraft: true,
        save: true,
        passive: isGeneralYetkiUser,
        active: isGeneralYetkiUser,
        remove: isGeneralYetkiUser,
    };

    // State declarations
    const [formShow, setFormShow] = useState(true);
    const [showReferansListe, setShowReferansListe] = useState(false);
    const [referansListeRows, setReferansListeRows] = useState([]);
    const [referansListeLoading, setReferansListeLoading] = useState(false);
    const [formReadOnly, setFormReadOnly] = useState(false);
    const [showYazdir, setShowYazdir] = useState(false);
    const [showAra, setShowAra] = useState(false);
    const [pendingReferenceApproval, setPendingReferenceApproval] = useState(null);
    const [referenceApprovalSending, setReferenceApprovalSending] = useState(false);
    const [yazdirLang, setYazdirLang] = useState('tr');
    const [crud, setCrud] = useState(safeCrud);
    const [formData, setFormData] = useState({});
    const openLegacyCari = useCallback(() => {
        const pointCarRef = Number(formData?.CAR_REF || props.ops?.CAR_REF || 0);
        if (!(pointCarRef > 0)) return;
        tabNavigation.openDetailTab(`LEGACY-CARI-${pointCarRef}`, `Eski CRM: ${pointCarRef}`, LegacyCariDfm, { initialPointCarRef: pointCarRef });
    }, [formData?.CAR_REF, props.ops?.CAR_REF, tabNavigation]);

    // Helper: safe access for crud
    const safeCrudAccess = (key) => (crud && typeof crud === 'object' && key in crud ? crud[key] : false);
    
    // Helper: field-level access control - ReadOnly
    const getFieldReadOnly = useCallback((fieldLabel, fieldName) => {
        // Yetkili açıklama genel yetkili için form kilidi ve alan hakkından bağımsız açık kalır.
        if (fieldName === 'CAR_NOT' && isCariGeneralAuthUser()) return false;
        const savedCari = Number(formData?.CAR_REF) > 0 && !isTempId(formData?.CAR_REF);
        if (savedCari && !canDeleteByOwner(glb.default?.KULLANICI, cariDataSahibiRef(formData))) return true;
        // Eğer formReadOnly ise zaten readonly
        if (formReadOnly) return true;
        if (isCariOwnerLockedField(fieldName, formData)) {
            return true;
        }
        // Yetkili Açıklama: admin/genel yetkili dışındaki kullanıcılar sadece atanmış kullanıcıysa düzenleyebilir
        if (fieldName === 'CAR_NOT') {
            const currentKul = Number(glb.default?.KULLANICI?.KUL_REF || 0);
            const assignedKul = Number(formData?.CAR_ARA_KUL_REF || 0);
            const girenKul = Number(formData?.CAR_GIR_KUL_REF || 0);
            const ownerKul = assignedKul > 0 ? assignedKul : girenKul;
            const isGeneralAuthUser =
                Number(glb.default?.KULLANICI?.KUL_YETKI) === 0 ||
                Number(glb.default?.KULLANICI?.KUL_YS) === 0 ||
                !!glb.default?.KULLANICI?.KUL_ISADMIN;
            if (!isGeneralAuthUser && ownerKul > 0 && currentKul !== ownerKul) {
                return true;
            }
        }
        // Eğer kullanıcı bu field'e özel olarak hak kısıtlaması var ise, readonly yap
        return utl.hasFieldRight(`CARIKART Giremez>>${fieldLabel}>>${fieldName}`);
    }, [formReadOnly, formData]);

    // Helper: field-level access control - Required
    const getIsFieldRequired = useCallback((fieldLabel, fieldName) => {
        // Eğer HAK tablosunda "Zorunlu" kaydı var ise, bu alan zorunlu
        return utl.hasFieldRight(`CARIKART Zorunlu>>${fieldLabel}>>${fieldName}`);
    }, []);

    const [formDataChanged, setFormDataChanged] = useState(false);
    // Child popups state
    const [formSatisShow, setFormSatisShow] = useState(false);
    const [formIslemGirShow, setFormIslemGirShow] = useState(false);
    const [formResimGirShow, setFormResimGirShow] = useState(false);
    const [formParaGirShow, setFormParaGirShow] = useState(false);
    const [formEkimKanalAlimGirShow, setFormEkimKanalAlimGirShow] = useState(false);
    // Benzer cari state
    const [benzerCariList, setBenzerCariList] = useState([]);
    // Telefon mükerrer uyarı popup
    const [showTelDupPopup, setShowTelDupPopup] = useState(false);
    const [telDupRows, setTelDupRows] = useState([]);
    const lastCheckedTel10Ref = useRef('');
    const telCheckInFlightRef = useRef(false);

    // İlk renderda veya ops değiştiğinde formu doldur
    React.useEffect(() => {
        lastCheckedTel10Ref.current = '';
        if (ops && ops.CAR_REF) {
            getFormData(ops);
        }
        // eslint-disable-next-line
    }, [ops && ops.CAR_REF]);

    // Not: Cari / WhatsApp açmak ? bildirimini düşürmez.
    // Düşme: gerçek dönüş (insan WA mesajı sync) veya arama kaydı.

    // Refs
    const formDataRef = useRef(null);
    const popupForm = useRef(null);
    const isMountedRef = useRef(true);
    const hasLoadedRef = useRef(false); // Popup gerçekten görünür olmadan veri çekme
    const lastLoadedCarRefRef = useRef(null);
    const carKeyRef = useRef(null); // Store key: CAR_REF veya temp (-99999999...)
    const lastWarnedCariRef = useRef(null);
    const lastApplicationAlertCariRef = useRef(null);
    const inTabMode = props.inTabMode === true;
    const [activeInnerTab, setActiveInnerTab] = useState(
        props.initialInnerTab || props.ops?.initialInnerTab || 'carikart'
    );
    const [loadedInnerTabs, setLoadedInnerTabs] = useState(() => new Set(['carikart']));
    const [innerRefreshToken, setInnerRefreshToken] = useState(0);
    const [meslekTick, setMeslekTick] = useState(0);
    const [formCevapCollapsedKeys, setFormCevapCollapsedKeys] = useState(() => new Set());
    const [reklamGorselGelis, setReklamGorselGelis] = useState(null);
    const rootScrollContainerRef = useRef(null);

    const meslekSelectItems = useMemo(() => {
        const arr = Array.isArray(glb.default.meslekLkp) ? glb.default.meslekLkp : [];
        return [...arr].sort((a, b) => String(a.MES_ADI || '').localeCompare(String(b.MES_ADI || ''), 'tr'));
    }, [meslekTick]);

    const formCevapRows = useMemo(
        () => (Array.isArray(formData?.FORM_CEVAPLAR) ? formData.FORM_CEVAPLAR : []),
        [formData?.FORM_CEVAPLAR]
    );
    const formGelisRows = useMemo(
        () => (Array.isArray(formData?.FORM_GELISLER) ? formData.FORM_GELISLER : []),
        [formData?.FORM_GELISLER]
    );
    const formGelisByRef = useMemo(() => {
        const map = new Map();
        formGelisRows.forEach((row) => {
            if (row?.CFG_REF != null) map.set(String(row.CFG_REF), row);
            if (row?.CFG_GELIS_NO != null) map.set(`no:${row.CFG_GELIS_NO}`, row);
        });
        return map;
    }, [formGelisRows]);
    const formCevapGridH = useMemo(
        () => gridHeightByRowCount(
            formCevapVisibleRowCount(formCevapRows, formCevapCollapsedKeys),
            FORM_CEVAP_GRID_MAX_H,
            FORM_CEVAP_GRID_H_OPTS
        ),
        [formCevapRows, formCevapCollapsedKeys]
    );
    const formGelisGridH = useMemo(
        () => gridHeightByRowCount(
            formGelisRows.length || 1,
            FORM_CEVAP_GRID_MAX_H,
            FORM_CEVAP_GRID_H_OPTS
        ),
        [formGelisRows]
    );
    /** Her iki sekme içeriği + tab chrome; TabPanel kırpmasın diye max alınır. */
    const formTabsPanelH = useMemo(
        () => Math.max(formCevapGridH, formGelisGridH + FORM_GELIS_LABEL_H) + FORM_TAB_CHROME_H,
        [formCevapGridH, formGelisGridH]
    );

    React.useEffect(() => {
        setFormCevapCollapsedKeys(new Set());
        setReklamGorselGelis(null);
    }, [formData?.CAR_REF, formData?.FORM_CEVAPLAR]);

    React.useEffect(() => {
        const bump = () => setMeslekTick((t) => t + 1);
        window.addEventListener(MESLEK_EVENT, bump);
        let cancel = false;
        // Login/auth zaten meslekLkp doldurur; boşsa bir kez çek, doluysa API yok.
        (async () => {
            try {
                await refreshGlobalMeslekLkp();
            } catch (e) {
                console.log(e);
            } finally {
                if (!cancel) bump();
            }
        })();
        return () => {
            cancel = true;
            window.removeEventListener(MESLEK_EVENT, bump);
        };
    }, []);

    // Screen data
    const screen = query(glb.default.EKRANLkp).filter(x => x.EKR_EKRANADI === 'cari').toArray()[0];

    const sendForm = useRef({
        data: {}, type: '', pnm: screen?.EKR_TABLOADI, uid: glb.default.KULLANICI.KUL_REF, vid: 1,
        cid: glb.default.KULLANICI.KUL_FIR_REF, defcid: glb.default.KULLANICI.KUL_DEF_FIR_REF,
        isource: 1, lang: glb.default.KULLANICI.KUL_DILKOD, inip: '??'
    });

    const formatNoteTimestamp = useCallback(() => {
        const d = new Date();
        const pad = (n) => String(n).padStart(2, '0');
        return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    }, []);

    const appendYetkiliNotTimestamp = useCallback((rawText) => {
        const text = String(rawText || '');
        const ts = `(${formatNoteTimestamp()})`;
        const hasTrailingTimestamp = /\(\d{2}\.\d{2}\.\d{4}\s\d{2}:\d{2}\)\s*$/.test(text);
        if (hasTrailingTimestamp) return text;
        if (text.trim().length === 0) return ts;
        return `${text} ${ts}`;
    }, [formatNoteTimestamp]);

    const appendYetkiliTimestampToLastLine = useCallback((rawText) => {
        const text = String(rawText || '');
        const lines = text.split('\n');
        const tsRegex = /\(\d{2}\.\d{2}\.\d{4}\s\d{2}:\d{2}\)\s*$/;

        let lastContentIdx = -1;
        for (let i = lines.length - 1; i >= 0; i -= 1) {
            if (String(lines[i] || '').trim().length > 0) {
                lastContentIdx = i;
                break;
            }
        }

        if (lastContentIdx === -1) {
            return `(${formatNoteTimestamp()})`;
        }

        const lastLineRaw = String(lines[lastContentIdx] || '');
        const lastLineTrimmedRight = lastLineRaw.replace(/\s+$/, '');
        if (tsRegex.test(lastLineTrimmedRight)) {
            return text;
        }

        lines[lastContentIdx] = `${lastLineTrimmedRight} (${formatNoteTimestamp()})`;
        return lines.join('\n');
    }, [formatNoteTimestamp]);

    const showCariUyariIfNeeded = useCallback((data) => {
        if (!data) return;
        const carRef = Number(data.CAR_REF || 0);
        const hasUyari = !!data.CAR_KISI_UYAR;
        const ack = String(data.CAR_ACK || '').trim();
        if (hasUyari && ack && carRef > 0 && lastWarnedCariRef.current !== carRef) {
            lastWarnedCariRef.current = carRef;
            notify(`UYARI: ${ack}`, 'warning', 5000);
        }
    }, []);

    const showApplicationAlertsIfNeeded = useCallback((data) => {
        const carRef = Number(data?.CAR_REF || 0);
        if (carRef <= 0 || lastApplicationAlertCariRef.current === carRef) return;
        lastApplicationAlertCariRef.current = carRef;

        Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}CARI_KART/applicationAlerts`, {
            params: { CAR_REF: carRef },
        })
            .then((response) => {
                if (!isMountedRef.current || lastLoadedCarRefRef.current !== carRef) return;
                const alert = response?.data || {};
                const messages = [];
                if (alert.nameMismatch) {
                    messages.push(
                        `Meta başvuru adı "${alert.leadName}" ile hasta kartı "${alert.cariName}" uyuşmuyor. `
                        + 'Telefon nedeniyle yanlış kişiyle eşleşmiş olabilir; lütfen kontrol edin.'
                    );
                }
                if (messages.length > 0) notify(`UYARI: ${messages.join(' ')}`, 'warning', 10000);
            })
            .catch(() => {
                if (lastApplicationAlertCariRef.current === carRef) {
                    lastApplicationAlertCariRef.current = null;
                }
            });
    }, []);

    // Callbacks
    const getFormData = useCallback((ops) => {
        if (!ops) return;
        const carRef = ops.CAR_REF;
        const cid = glb.default.KULLANICI.KUL_DEF_FIR_REF;
        const syncCacheKey = cariRecCacheKey(carRef, cid, 'update');
        const apiAp = ops.ap ?? 'update';

        const applyLocalPayload = (payload, { deferBenzer = false } = {}) => {
            if (!payload?.carikart) return false;
            let newFormData = ensureNewCariTrDil({
                ...payload.carikart,
                cariAramaList: payload.cariAramaList || [],
            });
            if (USE_CARI_MODEL_STORE) {
                let carKey = newFormData.CAR_REF;
                if (!carKey || carKey <= 0) {
                    carKey = nextTempCarRef();
                    newFormData = { ...newFormData, CAR_REF: carKey };
                }
                carKeyRef.current = carKey;
                cariModelStore.setModel(carKey, {
                    carikart: newFormData,
                    cariAramaList: newFormData.cariAramaList,
                    meta: { changed: false },
                });
            }
            lastLoadedCarRefRef.current = ops.CAR_REF;
            setFormData(newFormData);
            showCariUyariIfNeeded(newFormData);
            showApplicationAlertsIfNeeded(newFormData);
            setFormDataChanged(false);
            setFormShow(true);
            setFormReadOnly(ops.formReadOnly);
            setCrud(ops.crud);
            sendForm.current.type = ops.ptype;
            const shouldCheckSimilar = (newFormData.BENZER_VAR === true) || (props?.ops?.BENZER_VAR === true)
                || (!!newFormData.CAR_TEL1 || !!newFormData.CAR_GSM || !!newFormData.CAR_ADSOY);
            if (shouldCheckSimilar) {
                const runBenzer = () => {
                    if (!isMountedRef.current) return;
                    if (lastLoadedCarRefRef.current !== ops.CAR_REF) return;
                    loadBenzerCariList(ops.CAR_REF, newFormData.CAR_TEL1, newFormData.CAR_GSM, newFormData.CAR_ADSOY);
                };
                if (deferBenzer) window.setTimeout(runBenzer, 0);
                else runBenzer();
            } else {
                setBenzerCariList([]);
            }
            return true;
        };

        if (carRef) trackRecentEntity('cari', carRef);

        // 1) Store — senkron
        if (USE_CARI_MODEL_STORE && carRef) {
            const model = cariModelStore.getModel(carRef);
            if (model && model.carikart && Object.keys(model.carikart).length > 0) {
                applyLocalPayload({
                    carikart: model.carikart,
                    cariAramaList: model.cariAramaList || [],
                }, { deferBenzer: true });
                // Store yalnız kartı tutar; bağlı panellerin kanonik bundle cache'ini ayrıca hazırla.
                void ensureEntityBundleCached('cari', carRef);
                return;
            }
        }

        // 2) Bellek — senkron (IDB/network yok)
        const peeked = carRef ? peekLocalCariBundle(carRef) : getCached(syncCacheKey);
        if (peeked?.carikart) {
            applyLocalPayload(peeked, { deferBenzer: true });
            if (carRef) void refreshCariBundle(carRef).catch(() => null);
            return;
        }

        lastLoadedCarRefRef.current = ops.CAR_REF;
        if (carRef) {
            void (async () => {
                // 3) IndexedDB only — network yok
                try {
                    const local = await loadLocalCariBundle(carRef);
                    if (!isMountedRef.current) return;
                    if (lastLoadedCarRefRef.current !== ops.CAR_REF) return;
                    if (local?.carikart) {
                        applyLocalPayload(local, { deferBenzer: true });
                        void refreshCariBundle(carRef).catch(() => null);
                        return;
                    }
                } catch (_) { /* sunucuya düş */ }

                if (!isMountedRef.current) return;
                if (lastLoadedCarRefRef.current !== ops.CAR_REF) return;

                setFormData({});
                setFormDataChanged(false);
                getCachedOrFetch(syncCacheKey, async () => {
                    const res = await Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}CARI_KART/rec`, {
                        params: {
                            pnm: screen.EKR_TABLOADI,
                            CAR_REF: ops.CAR_REF,
                            ap: apiAp,
                            cid,
                            v: Date.now(),
                        },
                    });
                    return res?.data || null;
                })
                    .then((payload) => {
                        if (!isMountedRef.current) return;
                        if (lastLoadedCarRefRef.current !== ops.CAR_REF) return;
                        if (payload?.carikart) {
                            applyLocalPayload(payload);
                            void ensureEntityBundleCached('cari', carRef);
                        } else {
                            notify(Dict.get('anyItemNotFound'), 'warning');
                        }
                    })
                    .catch((err) => {
                        if (!isMountedRef.current) return;
                        lastLoadedCarRefRef.current = null;
                        const msg = err?.response?.data?.message || err?.response?.data?.error || err?.message || Dict.get('Cari kartı yüklenemedi');
                        notify(msg, 'error', 4000);
                    });
            })();
            return;
        }

        setFormData({});
        setFormDataChanged(false);
        getCachedOrFetch(syncCacheKey, async () => {
            const res = await Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}CARI_KART/rec`, {
                params: {
                    pnm: screen.EKR_TABLOADI,
                    CAR_REF: ops.CAR_REF,
                    ap: apiAp,
                    cid,
                    v: Date.now(),
                },
            });
            return res?.data || null;
        })
            .then((payload) => {
                if (!isMountedRef.current) return;
                if (payload?.carikart) applyLocalPayload(payload);
                else notify(Dict.get('anyItemNotFound'), 'warning');
            })
            .catch((err) => {
                if (!isMountedRef.current) return;
                lastLoadedCarRefRef.current = null;
                const msg = err?.response?.data?.message || err?.response?.data?.error || err?.message || Dict.get('Cari kartı yüklenemedi');
                notify(msg, 'error', 4000);
            });
    }, [screen, showApplicationAlertsIfNeeded, showCariUyariIfNeeded]);

    const loadBenzerCariList = useCallback((carRef, tel1, gsm, adsoy) => {
        const suffix = `${tel1 || ''}_${gsm || ''}_${(adsoy || '').slice(0, 30)}_ds`;
        const cacheKey = carRefCacheKey('BENZERCARI', carRef, suffix);
        const params = { CAR_REF: carRef };
        if (tel1) params.CAR_TEL1 = tel1; else params.CAR_TEL1 = '';
        if (gsm) params.CAR_GSM = gsm; else params.CAR_GSM = '';
        if (adsoy) params.CAR_ADSOY = adsoy; else params.CAR_ADSOY = '';
        getCachedOrFetch(cacheKey, async () => {
            const res = await Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}CARI_KART/benzercari`, { params });
            return Array.isArray(res?.data) ? res.data : [];
        })
            .then((list) => {
                if (!isMountedRef.current) return;
                setBenzerCariList(Array.isArray(list) ? list : []);
            })
            .catch(err => {
                if (!isMountedRef.current) return;
                console.error('Benzer cari yüklenemedi:', err);
                setBenzerCariList([]);
            });
    }, []);

    const handleBenzerCariClick = useCallback((e) => {
        if (!e.data) return;
        const clickedCari = e.data;
        // Tıklanan cariyi yükle - mevcut formun ops yapısını koruyarak
        const newOps = {
            CAR_REF: clickedCari.CAR_REF,
            ap: 'v',
            ptype: 'update',
            formReadOnly: formReadOnly,
            crud: crud
        };
        getFormData(newOps);
    }, [formReadOnly, crud, getFormData]);

    const openRefCariKart = useCallback((refCarRef) => {
        const id = Number(refCarRef || 0);
        if (!id) return;
        const newOps = {
            ...(props.ops || {}),
            CAR_REF: id,
            ap: 'v',
            ptype: 'update',
            formReadOnly,
            crud
        };
        if (tabNavigation && typeof tabNavigation.openDetailTab === 'function') {
            const uniqueKey = `CARI-${id}`;
            const title = `${Dict.get('Cari Kart')}: ${id}`;
            tabNavigation.openDetailTab(uniqueKey, title, Carikart, {
                ops: newOps,
                formShow: true,
                inTabMode: true,
                onFormKapandi: () => {}
            });
            return;
        }
        getFormData(newOps);
    }, [props.ops, formReadOnly, crud, getFormData, tabNavigation]);

    /** Son 10 hane; +90 / boşluk / tire vb. yok sayılır. */
    const normalizePhoneLast10 = useCallback((phone) => {
        const digits = String(phone || '').replace(/\D/g, '');
        if (!digits) return '';
        return digits.length > 10 ? digits.slice(-10) : digits;
    }, []);

    const checkPhoneDuplicatesOnExit = useCallback(async (rawPhone) => {
        if (formReadOnly) return;
        const tel10 = normalizePhoneLast10(rawPhone);
        if (tel10.length < 10) return;
        if (tel10 === lastCheckedTel10Ref.current) return;
        if (telCheckInFlightRef.current) return;
        telCheckInFlightRef.current = true;
        lastCheckedTel10Ref.current = tel10;
        try {
            const currentRef = Number(
                formDataRef.current?.instance?.option?.('formData')?.CAR_REF
                ?? formData?.CAR_REF
                ?? props.ops?.CAR_REF
                ?? 0
            ) || 0;
            const res = await Axios.post(`${process.env.REACT_APP_BACKEND_SERVER}CARI_KART/checkTel`, {
                phone: rawPhone,
                excludeCarRef: currentRef > 0 ? currentRef : 0,
            });
            if (!isMountedRef.current) return;
            const rows = Array.isArray(res?.data?.rows) ? res.data.rows : [];
            if (res?.data?.exists && rows.length > 0) {
                setTelDupRows(rows);
                setShowTelDupPopup(true);
            }
        } catch (err) {
            if (!isMountedRef.current) return;
            // Sessizce geç — kayıt girişini engelleme
            console.error('Telefon mükerrer kontrolü başarısız:', err);
            lastCheckedTel10Ref.current = '';
        } finally {
            telCheckInFlightRef.current = false;
        }
    }, [formReadOnly, formData?.CAR_REF, props.ops?.CAR_REF, normalizePhoneLast10]);

    const findSamePersonPhoneDuplicate = useCallback(async (fd) => {
        const name = normalizeCariPersonName(fd?.CAR_ADSOY);
        const phones = [...new Set(
            [fd?.CAR_TEL1, fd?.CAR_GSM]
                .map(normalizePhoneLast10)
                .filter((phone) => phone.length >= 10)
        )];
        if (!name || phones.length === 0) return null;

        const responses = await Promise.all(phones.map((phone) => Axios.post(
            `${process.env.REACT_APP_BACKEND_SERVER}CARI_KART/checkTel`,
            { phone, excludeCarRef: 0 }
        )));
        const rowsByRef = new Map();
        responses.forEach((response) => {
            const rows = Array.isArray(response?.data?.rows) ? response.data.rows : [];
            rows.forEach((row) => rowsByRef.set(Number(row?.CAR_REF || 0), row));
        });
        return [...rowsByRef.values()].find((row) => (
            normalizeCariPersonName(row?.CAR_ADSOY) === name
            && [row?.CAR_TEL1, row?.CAR_GSM]
                .map(normalizePhoneLast10)
                .some((phone) => phones.includes(phone))
        )) || null;
    }, [normalizePhoneLast10]);

    const phoneFieldEditorOptions = useCallback((fieldName, labelKey) => {
        const base = addMaxLengthToEditorOptions('CARI_KART', fieldName, {
            readOnly: getFieldReadOnly(labelKey, fieldName),
            mode: 'tel',
            acceptOnlyDigits: true,
            onFocusOut: (e) => {
                const value = typeof e?.event?.target?.value === 'string'
                    ? e.event.target.value
                    : (e?.component?.option?.('value') ?? '');
                checkPhoneDuplicatesOnExit(value);
            },
        });
        return base;
    }, [getFieldReadOnly, checkPhoneDuplicatesOnExit]);

    const validate = useCallback(() => {
        if (!formDataRef.current) return false;
        const res = formDataRef.current.instance.validate();
        return !res.brokenRules.length > 0;
    }, []);

    const doAlls = useCallback(async () => {
        let isapd = false;
        let currentFormData = null;
        if (sendForm.current.type === 'remove' || sendForm.current.type === 'active' || sendForm.current.type === 'passive') {
            sendForm.current.data = { id: formData.CAR_REF, enddt: formData.enddt };
            isapd = true;
        } else {
            currentFormData = formDataRef.current?.instance?.option('formData') || formData;
            const notEl = typeof document !== 'undefined' ? document.getElementById('bootstrap-form-CAR_NOT') : null;
            if (currentFormData && notEl && String(notEl.value || '').trim()) {
                const stamped = appendYetkiliTimestampToLastLine(notEl.value);
                if (String(currentFormData.CAR_NOT || '') !== stamped) {
                    currentFormData.CAR_NOT = stamped;
                }
            }
            sendForm.current.data = currentFormData;
        }

        if (USE_CARI_MODEL_STORE && !isapd) {
            const carKey = carKeyRef.current ?? formData.CAR_REF;
            if (carKey != null) {
                const instData = formDataRef.current?.instance?.option('formData') || formData;
                const existing = cariModelStore.getModel(carKey)?.carikart || {};
                const refMergeKeys = [
                    'CAR_REF_C_REF',
                    'CAR_ILK_REF',
                    'CAR_ILK_REF_C_REF',
                    'CAR_ILK_REF_ADI',
                    'CAR_ILK_REF_ULASIM',
                    'CAR_SON_REF_C_REF',
                    'CAR_SON_REF_ADI',
                    'CAR_SON_REF_ULASIM',
                    'CARI_REFERANS_ADI'
                ];
                const mergedCarikart = { ...existing, ...instData };
                if (currentFormData?.CAR_NOT != null && String(currentFormData.CAR_NOT) !== String(mergedCarikart.CAR_NOT || '')) {
                    mergedCarikart.CAR_NOT = currentFormData.CAR_NOT;
                }
                for (const k of refMergeKeys) {
                    if (!Object.prototype.hasOwnProperty.call(instData, k) && Object.prototype.hasOwnProperty.call(existing, k)) {
                        mergedCarikart[k] = existing[k];
                    }
                }
                cariModelStore.setModel(carKey, {
                    carikart: mergedCarikart,
                    cariAramaList: instData.cariAramaList || [],
                });
                syncCarikart(carKey, {
                    sekme: 'Cari Bilgileri',
                    onSuccess: (resData) => {
                        const realRef = resData?.CAR_REF ?? resData?.carikart?.CAR_REF;
                        if (realRef != null && isTempId(carKey)) {
                            carKeyRef.current = realRef;
                            setFormData((prev) => ({
                                ...(prev || {}),
                                CAR_REF: realRef
                            }));
                            setFormDataChanged(false);
                        }
                        const aff = Array.isArray(resData?.affectedIlkCarRefs)
                            ? resData.affectedIlkCarRefs.map(Number).filter((n) => Number.isFinite(n) && n > 0)
                            : [];
                        const sv = Number(realRef ?? carKey);
                        const affectedCarRefs = [...new Set(sv > 0 ? [...aff, sv] : aff)];
                        emitCariSync({
                            carRef: sv > 0 ? sv : (realRef ?? carKey),
                            source: 'carikart',
                            affectedCarRefs
                        });
                    },
                });
            }
            return;
        }

        await Axios.post(`${process.env.REACT_APP_BACKEND_SERVER}` + (isapd ? 'doalls' : sendForm.current.pnm + `/` + sendForm.current.type), sendForm.current)
            .then(res => {
                if (res.data.iserr === true) {
                    notify(Dict.get('serverError') + res.data.errmsg, 'error');
                }
                else {
                    notify(Dict.get('Cari Kaydedildi'), 'success');
                    const savedRef = Number(sendForm.current?.data?.CAR_REF || formData?.CAR_REF || 0);
                    const aff = Array.isArray(res.data?.affectedIlkCarRefs)
                        ? res.data.affectedIlkCarRefs.map(Number).filter((n) => Number.isFinite(n) && n > 0)
                        : [];
                    const affectedCarRefs = [...new Set(savedRef > 0 ? [...aff, savedRef] : aff)];
                    emitCariSync({
                        carRef: sendForm.current?.data?.CAR_REF || formData?.CAR_REF,
                        source: 'carikart',
                        affectedCarRefs
                    });
                }
            }).catch(err => {
                notify(Dict.get('serverError') + err, 'error');
            });
    }, [formData, appendYetkiliTimestampToLastLine]);

    const formEKIndir_click = useCallback(async () => {
        await Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}sablonops/getSacekEk?CAR_REF=${formData.CAR_REF}&cid=${glb.default.KULLANICI.KUL_DEF_FIR_REF}`,
            { responseType: 'blob' }
        )
            .then(response => {
                const blob = new Blob([response.data],
                    { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });

                const a = document.createElement('a');
                a.style.display = 'none';
                document.body.appendChild(a);
                const url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = 'SacekEk_' + formData.CAR_ADSOY + '.docx';
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }).catch(err => {
                notify(Dict.get('serverError') + err, 'error');
            });
    }, [formData.CAR_REF, formData.CAR_ADSOY]);

    const formPRPIndir_click = useCallback(async () => {
        await Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}sablonops/getSacekPRP?CAR_REF=${formData.CAR_REF}&cid=${glb.default.KULLANICI.KUL_DEF_FIR_REF}`,
            { responseType: 'blob' }
        )
            .then(response => {
                const blob = new Blob([response.data],
                    { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });

                const a = document.createElement('a');
                a.style.display = 'none';
                document.body.appendChild(a);
                const url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = 'SacekPDF_' + formData.CAR_ADSOY + '.docx';
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }).catch(err => {
                notify(Dict.get('serverError') + err, 'error', 2000);
            });
    }, [formData.CAR_REF, formData.CAR_ADSOY]);

    const formYazdir_click = useCallback((lang) => {
        setShowYazdir(true);
        setYazdirLang(lang);
    }, []);

    const yazFormHiding = useCallback(() => {
        if (!isMountedRef.current) return;
        setShowYazdir(false);
    }, []);

    const formAra_click = useCallback(() => {
        setShowAra(true);
    }, []);

    const sendReferenceApproval = useCallback(async () => {
        const carRef = Number(formDataRef.current?.instance?.option?.('formData')?.CAR_REF || formData?.CAR_REF || 0);
        if (!carRef || !pendingReferenceApproval?.CAR_REF) {
            notify('Onay talebi göndermek için önce cari kaydını kaydedin.', 'warning', 3000);
            return;
        }
        try {
            setReferenceApprovalSending(true);
            const response = await Axios.post(`${process.env.REACT_APP_BACKEND_SERVER}report/onay/referans_talep`, {
                carRef,
                referenceCarRef: Number(pendingReferenceApproval.CAR_REF),
            });
            notify(response?.data?.created === false
                ? 'Bu referans için bekleyen bir onay talebiniz zaten var.'
                : 'Referans seçimi yönetici onayına gönderildi.', 'success', 3500);
            setPendingReferenceApproval(null);
            window.dispatchEvent(new Event('approval-notifications-refresh'));
        } catch (err) {
            notify(err?.response?.data?.message || 'Onay talebi gönderilemedi.', 'error', 4000);
        } finally {
            setReferenceApprovalSending(false);
        }
    }, [formData?.CAR_REF, pendingReferenceApproval]);

    const openReferansListe = useCallback(async () => {
        const inst = formDataRef.current?.instance;
        const fd = inst?.option('formData') || formData || {};
        const id = Number(fd.CAR_REF);
        if (!id || id <= 0) return;
        setShowReferansListe(true);
        setReferansListeLoading(true);
        try {
            const res = await Axios.get(`${process.env.REACT_APP_BACKEND_SERVER}CARI_KART/refliste`, {
                params: { CAR_REF: id, v: Date.now() }
            });
            setReferansListeRows(Array.isArray(res?.data) ? res.data : []);
        } catch (e) {
            console.error(e);
            setReferansListeRows([]);
            notify(Dict.get('serverError') + (e?.message || e), 'error');
        } finally {
            setReferansListeLoading(false);
        }
    }, [formData]);

    const refVarCheckboxChanged = useCallback((value) => {
        const inst = formDataRef.current?.instance;
        if (inst) {
            inst.updateData('CAR_REF_VAR', value);
            if (USE_CARI_MODEL_STORE && carKeyRef.current != null) {
                const latest = inst.option('formData');
                if (latest) cariModelStore.updateCarikart(carKeyRef.current, latest);
            }
        }
        setFormData((prev) => ({ ...(prev || {}), CAR_REF_VAR: value }));
        setFormDataChanged(true);
    }, []);

    const araFormHiding = useCallback(() => {
        if (!isMountedRef.current) return;
        setShowAra(false);
    }, []);



    const formHiding = useCallback(() => {
        if (!isMountedRef.current) return;
        setFormData({});
        if (props.onFormKapandi) {
            props.onFormKapandi();
        }
        setFormShow(false);
        hasLoadedRef.current = false; // tekrar açıldığında yeniden lazy load edilsin
    }, [props]);

    const validateCariKartBeforeSave = useCallback((fd) => {
        const data = fd || formDataRef.current?.instance?.option?.('formData') || formData;
        if (selectedUlasimRequiresReference(data) && !Number(data.CAR_REF_C_REF)) {
            notify(Dict.get('Referans seçilmesi zorunludur'), 'error');
            return false;
        }
        if (Number(data.CAR_BULUSMA_REF) === 432 && (data.CAR_ACENTA_REF == null || data.CAR_ACENTA_REF === undefined || Number(data.CAR_ACENTA_REF) === 0)) {
            notify(Dict.get('Acente seçilmesi zorunludur'), 'error');
            return false;
        }
        const delphiMissing = collectDelphiCariKartMissing(data);
        if (delphiMissing.length > 0) {
            notify(`${delphiMissing.join(', ')} Boş Geçilemez`, 'error', 3500);
            return false;
        }
        if (!validate()) return false;
        if (data.CAR_DONCE_SAC_EKIM_VAR === true && !String(data.CAR_ESKISACZMN || '').trim()) {
            notify(`${Dict.get('Eski Saç Ekim Var?')} seçiliyse ${Dict.get('Açıklama')} zorunludur.`, 'error');
            return false;
        }
        return true;
    }, [formData, validate]);

    const formSaveAndClose_click = useCallback(async () => {
        if (formData.CAR_REF && formData.CAR_REF > 0 && formDataChanged === false) {
            notify(Dict.get('Değişiklik Bulunamadı'), 'error');
            return;
        }
        if (!validateCariKartBeforeSave()) return;
        await doAlls();
        formHiding();
    }, [formData, formDataChanged, validateCariKartBeforeSave, doAlls, formHiding]);

    // Sekme içi üst toolbar butonları
    const doCrudAction = useCallback(async (type) => {
        if (!type) return;
        const savedCari = Number(formData?.CAR_REF) > 0 && !isTempId(formData?.CAR_REF);
        const changingExisting = type === 'passive' || type === 'active' || type === 'remove'
            || (String(type).startsWith('save') && savedCari);
        if (changingExisting && !canDeleteByOwner(glb.default?.KULLANICI, cariDataSahibiRef(formData))) {
            notify(FOREIGN_DELETE_MESSAGE, 'warning', 3000);
            return;
        }
        if (type === 'saveTest' || type === 'saveDraft' || type === 'save') {
            if (formData.CAR_REF && formData.CAR_REF > 0 && formDataChanged === false && type !== 'saveTest') {
                notify(Dict.get('Değişiklik Bulunamadı'), 'error');
                return;
            }
            if (!validateCariKartBeforeSave()) return;
            const fd = formDataRef.current?.instance?.option?.('formData') || formData || {};
            const isNewCari = !(Number(fd.CAR_REF) > 0) || isTempId(fd.CAR_REF);
            if (isNewCari && !fd.ALLOW_DUPLICATE) {
                try {
                    const duplicate = await findSamePersonPhoneDuplicate(fd);
                    if (duplicate) {
                        const devam = window.confirm('Aynı telefon ve ad soyad ile kayıtlı bir cari var. Yine de yeni cari oluşturmak istiyor musunuz?');
                        if (!devam) {
                            handleBenzerCariClick({ data: duplicate });
                            return;
                        }
                        const nextFd = { ...fd, ALLOW_DUPLICATE: true };
                        formDataRef.current?.instance?.option?.('formData', nextFd);
                        setFormData(nextFd);
                        if (carKeyRef.current != null) cariModelStore.updateCarikart(carKeyRef.current, nextFd);
                    }
                } catch (err) {
                    notify('Mükerrer cari kontrolü yapılamadı. Lütfen tekrar deneyin.', 'error', 3000);
                    return;
                }
            }
        }
        sendForm.current.type = type;
        await doAlls();
        if (type.startsWith('save')) setFormDataChanged(false);
    }, [formData, formDataChanged, validateCariKartBeforeSave, doAlls, findSamePersonPhoneDuplicate, handleBenzerCariClick]);

    const formFieldDataChanged = useCallback((e) => {
        if (e?.dataField) {
            setFormData((prev) => ({ ...(prev || {}), [e.dataField]: e.value }));
        }
        if (USE_CARI_MODEL_STORE && carKeyRef.current != null) {
            const latest = e?.component?.option?.('formData') || formDataRef.current?.instance?.option?.('formData');
            if (latest) {
                cariModelStore.updateCarikart(carKeyRef.current, latest);
                if (Array.isArray(latest.cariAramaList)) {
                    cariModelStore.setCariAramaList(carKeyRef.current, latest.cariAramaList);
                }
            }
        }
        setFormDataChanged(true);
    }, []);

    const ulkeSec = useCallback((e) => {
        if (formDataRef.current) {
            formDataRef.current.instance.updateData('CAR_IL', null);
            formDataRef.current.instance.updateData('CAR_SEMT', null);
        }
        setFormData((prev) => ({ ...(prev || {}), CAR_ULKE: e.value, CAR_IL: null, CAR_SEMT: null }));
    }, []);

    const sehirSec = useCallback((e) => {
        if (formDataRef.current) {
            formDataRef.current.instance.updateData('CAR_SEMT', null);
        }
        setFormData((prev) => ({ ...(prev || {}), CAR_IL: e.value, CAR_SEMT: null }));
    }, []);

    // Mount/unmount guard only
    useEffect(() => {
        isMountedRef.current = true;
        return () => { isMountedRef.current = false; };
    }, []);

    // CAR_REF değiştiğinde inner state sıfırla (yeni cari veya benzer cari tıklama).
    // Cache temizleme YAPMA – birden fazla cari sekmesi açıkken diğerine geçip geri dönünce
    // aynı veriyi cache/store'dan okumalı, yeniden GET atmamalı.
    useEffect(() => {
        setActiveInnerTab('carikart');
        setLoadedInnerTabs(new Set(['carikart']));
        setInnerRefreshToken(0);
    }, [props.ops?.CAR_REF]);

    useEffect(() => {
        const refZincirKeys = [
            'CAR_REF_C_REF',
            'CAR_ILK_REF',
            'CAR_ILK_REF_C_REF',
            'CAR_ILK_REF_ADI',
            'CAR_ILK_REF_ULASIM',
            'CAR_SON_REF_C_REF',
            'CAR_SON_REF_ADI',
            'CAR_SON_REF_ULASIM',
            'CARI_REFERANS_ADI'
        ];
        const pickRefZinciriFromCarikart = (fc) => {
            const o = {};
            if (!fc) return o;
            for (const k of refZincirKeys) {
                if (Object.prototype.hasOwnProperty.call(fc, k)) o[k] = fc[k];
            }
            return o;
        };

        const unsub = subscribeCariSync((evt) => {
            const cid = glb.default.KULLANICI.KUL_DEF_FIR_REF;
            const ap = props.ops?.ap ?? 'v';

            if (evt?.source === 'carikart' && Array.isArray(evt.affectedCarRefs) && evt.affectedCarRefs.length) {
                const cur = Number(formData?.CAR_REF ?? props.ops?.CAR_REF ?? 0);
                for (const raw of evt.affectedCarRefs) {
                    const r = Number(raw);
                    if (!Number.isFinite(r) || r <= 0) continue;
                    clearCached(cariRecCacheKey(r, cid, ap));
                    const m = cariModelStore.getModel(r);
                    if (!m) continue;
                    if (m.meta?.changed) {
                        if (!screen?.EKR_TABLOADI) continue;
                        (async () => {
                            try {
                                const res = await Axios.get(
                                    `${process.env.REACT_APP_BACKEND_SERVER}CARI_KART/rec`,
                                    {
                                        params: {
                                            pnm: screen.EKR_TABLOADI,
                                            CAR_REF: r,
                                            ap,
                                            cid,
                                            v: Date.now()
                                        }
                                    }
                                );
                                const fc = res?.data?.carikart;
                                if (!fc || !isMountedRef.current) return;
                                const patch = pickRefZinciriFromCarikart(fc);
                                if (Object.keys(patch).length === 0) return;
                                cariModelStore.updateCarikart(r, patch);
                                if (cur === r) {
                                    const inst = formDataRef.current?.instance;
                                    if (inst) {
                                        Object.entries(patch).forEach(([k, v]) => inst.updateData(k, v));
                                    }
                                    setFormData((prev) => ({ ...(prev || {}), ...patch }));
                                }
                            } catch (_) { /* ignore */ }
                        })();
                    } else {
                        cariModelStore.removeModel(r);
                        if (cur === r && props.ops?.CAR_REF) {
                            getFormData(props.ops);
                        }
                    }
                }
            }

            const currentCarRef = formData?.CAR_REF ?? props.ops?.CAR_REF;
            if (!currentCarRef) return;
            if (Number(evt?.carRef) !== Number(currentCarRef)) return;

            if (evt?.source === 'sync') {
                // Bundle is already refreshed by syncService. Keep unsaved call drafts
                // and customer edits while applying the new call history.
                void loadLocalCariBundle(currentCarRef).then((bundle) => {
                    if (!isMountedRef.current || !Array.isArray(bundle?.cariAramaList)) return;
                    if (Number(lastLoadedCarRefRef.current) !== Number(currentCarRef)) return;
                    const mergeCalls = (rows) => [
                        ...(Array.isArray(rows) ? rows : []).filter((row) =>
                            Number(row.CD_REF) === -1 || isTempId(row.CD_REF)),
                        ...bundle.cariAramaList,
                    ];
                    const model = cariModelStore.getModel(currentCarRef);
                    if (model) {
                        cariModelStore.setModel(currentCarRef, {
                            ...model,
                            cariAramaList: mergeCalls(model.cariAramaList),
                            meta: { ...model.meta },
                        });
                    }
                    setFormData((prev) => ({
                        ...prev,
                        cariAramaList: mergeCalls(prev?.cariAramaList),
                    }));
                }).catch(() => null);
            } else if (evt?.source === 'satis') {
                clearCached(carRefCacheKey('PARA_OZET', currentCarRef));
                // Satış payload'ı alt panellerce doğrudan uygulanır. Ardından tek bundle
                // isteği bütün requestCache anahtarlarını atomik olarak tazeler; /rec yoktur.
                void refreshCariBundle(currentCarRef).then((bundle) => {
                    if (!bundle?.carikart || !isMountedRef.current || formDataChanged) return;
                    setFormData((prev) => ({
                        ...(prev || {}),
                        ...bundle.carikart,
                        cariAramaList: bundle.cariAramaList || prev?.cariAramaList || [],
                    }));
                }).catch(() => null);
            } else if (evt?.source === 'para') {
                clearCached(carRefCacheKey('PARA_OZET', currentCarRef));
            } else if (evt?.source === 'islem') {
                clearCached(carRefCacheKey('ISLEMLIST_BY_CAR', currentCarRef));
            }
        });
        return () => unsub();
    }, [formData?.CAR_REF, props.ops, getFormData, screen, formDataChanged]);

    // Lazy load: sadece popup görünür olduğunda ve CAR_REF değiştiğinde veri çek
    useEffect(() => {
        if (!screen) return;
        const visible = inTabMode || (props.formShow && formShow);
        if (!visible) return;

        const carRef = props.ops?.CAR_REF;
        const shouldReload = !hasLoadedRef.current || lastLoadedCarRefRef.current !== carRef;
        if (!shouldReload) return;

        const loadData = async () => {
            getFormData(props.ops);
        };

        loadData().finally(() => {
            hasLoadedRef.current = true;
            lastLoadedCarRefRef.current = carRef;
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [screen, props.formShow, formShow, props.ops?.CAR_REF]);

    useEffect(() => {
        const cleanup = enableGridWheelOuterScroll(rootScrollContainerRef.current);
        return cleanup;
    }, []);

    useEffect(() => {
        const el = rootScrollContainerRef.current;
        if (!el) return undefined;
        return attachFormEnterToNextField(el);
    }, []);

    const canSeeSatisTab = (() => {
        try {
            const arr = query(glb.default.EKRANLkp).filter(x => x.EKR_EKRANADI === 'carisatis').toArray();
            return Array.isArray(arr) && arr.length > 0;
        } catch {
            return false;
        }
    })();
    // Resim ve Ekim/Kanal panelleri Satış ekranının içine gömülmez; ayrı cari sekmelerinde açılır.
    const hideRedundantTabsWhenSatis = false;
    const redundantTabKeys = new Set(['para', 'islem', 'resim', 'ekim']);

    useEffect(() => {
        if (!inTabMode) return;
        if (!hideRedundantTabsWhenSatis) return;
        if (!redundantTabKeys.has(activeInnerTab)) return;
        // Satış sekmesi görünüyorsa, diğer girişleri gizle ve kullanıcıyı satışa al.
        setActiveInnerTab('satis');
        setLoadedInnerTabs((prev) => {
            if (prev.has('satis')) return prev;
            const next = new Set(prev);
            next.add('satis');
            return next;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inTabMode, hideRedundantTabsWhenSatis, activeInnerTab]);

    // Early return after all hooks
    if (!screen) {
        notify(Dict.get('NotAuthThisScreen'), 'error');
        return <Redirect to="/" />;
    }

    const openInnerTab = (tabKey) => {
        if (inTabMode && hideRedundantTabsWhenSatis && redundantTabKeys.has(tabKey)) {
            setActiveInnerTab('satis');
            setLoadedInnerTabs((prev) => {
                if (prev.has('satis')) return prev;
                const next = new Set(prev);
                next.add('satis');
                return next;
            });
            return;
        }
        setActiveInnerTab(tabKey);
        // refreshToken sadece sync event'inde artırılmalı; sekme geçişinde artırmayoruz (gereksiz API isteklerini önler)
        setLoadedInnerTabs((prev) => {
            if (prev.has(tabKey)) return prev;
            const next = new Set(prev);
            next.add(tabKey);
            return next;
        });
    };

    const cariSaved = Number(formData?.CAR_REF) > 0 && !isTempId(formData?.CAR_REF);
    const canChangeThisCari = !cariSaved || canDeleteByOwner(glb.default?.KULLANICI, cariDataSahibiRef(formData));
    const cariFormLocked = formReadOnly || !canChangeThisCari;

    return (
        <React.Fragment>
            {/* Ana Form Popup */}
            <div ref={rootScrollContainerRef} className="cari-form-compact" style={{
                width: '100%',
                maxWidth: '100%',
                height: '100%',
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'column'
            }}>
               

                {inTabMode && !!formData?.CAR_REF && (
                    <div style={{ display: 'flex', gap: '8px', marginBottom: '12px', flexWrap: 'wrap' }}>
                        <Button text={Dict.get('Cari Kart')} type={activeInnerTab === 'carikart' ? 'default' : 'normal'} stylingMode={activeInnerTab === 'carikart' ? 'contained' : 'outlined'} onClick={() => openInnerTab('carikart')} />
                        {canSeeSatisTab && (
                            <Button text={Dict.get('Satış Gir')} type={activeInnerTab === 'satis' ? 'default' : 'normal'} stylingMode={activeInnerTab === 'satis' ? 'contained' : 'outlined'} onClick={() => openInnerTab('satis')} />
                        )}
                        {!hideRedundantTabsWhenSatis && (
                            <>
                                <Button text={Dict.get('İşlem Gir')} type={activeInnerTab === 'islem' ? 'default' : 'normal'} stylingMode={activeInnerTab === 'islem' ? 'contained' : 'outlined'} onClick={() => openInnerTab('islem')} />
                                <Button text={Dict.get('Resim Gir')} type={activeInnerTab === 'resim' ? 'default' : 'normal'} stylingMode={activeInnerTab === 'resim' ? 'contained' : 'outlined'} onClick={() => openInnerTab('resim')} />
                                <Button text={Dict.get('Ekim/Kanal Alım')} type={activeInnerTab === 'ekim' ? 'default' : 'normal'} stylingMode={activeInnerTab === 'ekim' ? 'contained' : 'outlined'} onClick={() => openInnerTab('ekim')} />
                                <Button text={Dict.get('Borç/Alınan')} type={activeInnerTab === 'para' ? 'default' : 'normal'} stylingMode={activeInnerTab === 'para' ? 'contained' : 'outlined'} onClick={() => openInnerTab('para')} />
                            </>
                        )}
                        {!!formData?.CAR_REF && (
                            <Button
                                text={formData?.CAR_SS_WHATSAPP ? 'WhatsApp ●' : (Dict.get('WhatsApp') || 'WhatsApp')}
                                type={activeInnerTab === 'whatsapp' ? 'default' : 'normal'}
                                stylingMode={activeInnerTab === 'whatsapp' ? 'contained' : 'outlined'}
                                onClick={() => openInnerTab('whatsapp')}
                            />
                        )}
                    </div>
                )}

                {/* Benzer Cari Grid - sadece BENZER_VAR true ise göster */}
                {(!inTabMode || activeInnerTab === 'carikart') && benzerCariList && benzerCariList.length > 0 && (
                    <div style={{
                        marginBottom: '12px',
                        padding: '12px',
                        background: '#fff3cd',
                        border: '2px solid #ffc107',
                        borderRadius: '6px'
                    }}>
                        <h4 style={{
                            margin: '0 0 8px 0',
                            fontSize: '14px',
                            fontWeight: 600,
                            color: '#856404'
                        }}>
                            ⚠️ Benzer Cariler Bulundu ({benzerCariList.length})
                        </h4>
                        <DataGrid
                            dataSource={benzerCariList}
                            showBorders={true}
                            keyExpr="CAR_REF"
                            height={120}
                            columnAutoWidth={false}
                            columnMinWidth={120}
                            hoverStateEnabled={true}
                            onRowClick={handleBenzerCariClick}>
                            <Selection mode="single" />
                            <Scrolling mode="standard" useNative={false} showScrollbar="always" columnRenderingMode="standard" />
                            <LoadPanel enabled={true} />
                            <Column dataField="CAR_REF" caption={Dict.get('id')} width={80} />
                            <Column {...addMaxLengthToGridColumn('CARI_KART', 'CAR_ADSOY', {
                                dataField: "CAR_ADSOY", 
                                caption: Dict.get('Ad Soyad')
                            })} />
                            <Column dataField="DATA_SAHIBI" caption="Data Sahibi" width={140} />
                            <Column {...addMaxLengthToGridColumn('CARI_KART', 'CAR_GSM', {
                                dataField: "CAR_GSM", 
                                caption: Dict.get('GSM1'),
                                width: 120
                            })} />
                            <Column {...addMaxLengthToGridColumn('CARI_KART', 'CAR_TEL1', {
                                dataField: "CAR_TEL1", 
                                caption: Dict.get('GSM2'),
                                width: 120
                            })} />
                            <Column dataField="CAR_CINSIYET" caption={Dict.get('Cinsiyet')} width={80} />
                            <Column dataField="ULKE_AD" caption={Dict.get('Ülke')} width={100} />
                            <Column dataField="SON_DEG" caption={Dict.get('Son Değerlendirme')} />
                            <Column dataField="SON_DURUM" caption={Dict.get('Son Durum')} />
                            <Column dataField="isactive" caption={Dict.get('isactive')} width={80} />
                        </DataGrid>
                    </div>
                )}

                {(!inTabMode || activeInnerTab === 'carikart') && (
                <ScrollView id={'scrollview'} width='100%' height='100%' style={{ flex: 1 }}>
                    <Form ref={formDataRef} formData={formData} showValidationSummary={true} labelLocation='left' colCount={1} scrollingEnabled={false} showColonAfterLabel={true}
                        readOnly={cariFormLocked} hoverStateEnabled={false} onFieldDataChanged={formFieldDataChanged} width='100%'>
                        <GroupItem colCount={12}>
                            <GroupItem colSpan={inTabMode ? 6 : 5} cssClass="custom-group-item">
                                <GroupItem colCount={1}>
                                    <SimpleItem render={() => (
                    <div className="cari-card-header">
                        <div className="cari-card-header__title">
                            <span style={{ fontSize: '18px' }}>👤</span>
                            {Dict.get('Cari Bilgileri')}
                        </div>

                        <div className="cari-card-header__actions">
                            {safeCrudAccess('save') && canChangeThisCari && <Button icon="save" text={Dict.get('Cari Kaydet')} type="success" stylingMode="contained" onClick={() => doCrudAction('save')} />}
                            {props.ops?.ptype === 'insert' && <Button icon="close" text={Dict.get('Vazgeç')} stylingMode="outlined" onClick={formHiding} />}
                            {Number(formData?.CAR_REF) > 0 && canDeleteByOwner(glb.default?.KULLANICI, cariDataSahibiRef(formData)) && (
                                <Button icon="trash" text="Cari Sil" type="danger" stylingMode="contained" onClick={() => {
                                    if (!window.confirm('Bu cari kart silinsin mi?')) return;
                                    doCrudAction('remove');
                                }} />
                            )}
                            {canChangeThisCari && <Button icon="minus" text={Dict.get('Cari Pasif Yap')} stylingMode="outlined" onClick={() => doCrudAction('passive')} />}
                            {canChangeThisCari && <Button icon="check" text={Dict.get('Cari Aktif Yap')} stylingMode="outlined" onClick={() => doCrudAction('active')} />}
                            <Button icon="print" text={Dict.get('Yazdır TR')} onClick={() => formYazdir_click('tr')} disabled={!formData?.CAR_REF} />
                            <Button icon="print" text={Dict.get('Yazdır EN')} onClick={() => formYazdir_click('en')} disabled={!formData?.CAR_REF} />
                            <Button text="Eski CRM" stylingMode="outlined" onClick={openLegacyCari} disabled={!(Number(formData?.CAR_REF) > 0)} />
                        </div>
                    </div>
                )} />
                                </GroupItem>

                                <GroupItem colCount={12} cssClass="cari-mesaj-atma">
                                    <SimpleItem
                                        colSpan={12}
                                        dataField="CAR_MESAJ_ATMA"
                                        editorType="dxCheckBox"
                                        editorOptions={{ readOnly: getFieldReadOnly('Kesinlikle mesaj atma', 'CAR_MESAJ_ATMA') }}
                                    >
                                        <Label text="Kesinlikle mesaj atma (şikayetçi — toplu WhatsApp listesine girmez)" />
                                    </SimpleItem>
                                </GroupItem>

                                <GroupItem colCount={2}>
                                    <SimpleItem>
                                        <Label text={Dict.get('Giriş Tar.')} />
                                        <QuickDateTimeBox
                                            value={formData?.CAR_GIR_TAR}
                                            readOnly={getFieldReadOnly('Giriş Tar.', 'CAR_GIR_TAR') || props.ops.ptype !== 'insert' || glb.default.KULLANICI.KUL_YETKI !== 0}
                                            onValueChanged={(v) => {
                                                formDataRef.current?.instance?.updateData('CAR_GIR_TAR', v);
                                                setFormDataChanged(true);
                                            }}
                                        />
                                    </SimpleItem>
                                    <SimpleItem dataField='CAR_MED_REF' editorType="dxNumberBox" editorOptions={{ readOnly: getFieldReadOnly('Medsis No', 'CAR_MED_REF'), max: 999999999999999, format: { type: 'fixedPoint', precision: 0 } }}><Label text={Dict.get('Medsis No')} /></SimpleItem>
                                </GroupItem>

                                <GroupItem colCount={2}>
                                    <SimpleItem 
                                        dataField='CAR_ADSOY' 
                                        editorType="dxTextBox" 
                                        editorOptions={addMaxLengthToEditorOptions('CARI_KART', 'CAR_ADSOY', {
                                            readOnly: getFieldReadOnly('Adı Soyadı', 'CAR_ADSOY')
                                        })}>
                                        <RequiredRule message={Dict.get('Adı Soyad') + ' ' + Dict.get('isRequired')} />
                                        <Label text={Dict.get('Adı Soyadı')} />
                                    </SimpleItem>
                                    <SimpleItem dataField='CAR_ARA_KUL_REF' enabled={isCariGeneralAuthUser() || !Number(formData?.CAR_ARA_KUL_REF)}
                                        editorType='dxSelectBox' editorOptions={{
                                            readOnly: isCariOwnerLockedField('CAR_ARA_KUL_REF', formData),
                                            items: getSelectableUsersWithIncluded(glb.default.KULLANICILkp, [formData?.CAR_ARA_KUL_REF]),
                                            searchEnabled: true, searchMode: 'contains', displayExpr: 'KUL_ADI', searchExpr: 'KUL_ADI', valueExpr: 'KUL_REF'
                                        }}><Label text={Dict.get('Data Sahibi')}></Label>
                                    </SimpleItem>
                                </GroupItem>

                                <GroupItem colCount={2}>
                                    <SimpleItem dataField="CAR_GSM" editorOptions={phoneFieldEditorOptions('CAR_GSM', 'GSM1')}>
                                        {getIsFieldRequired('GSM1', 'CAR_GSM') && <RequiredRule message={Dict.get('GSM1') + ' ' + Dict.get('isRequired')} />}
                                        <Label text={Dict.get('GSM1')}></Label>
                                    </SimpleItem>
                                    <SimpleItem dataField="CAR_TEL1" editorOptions={phoneFieldEditorOptions('CAR_TEL1', 'GSM2')}>
                                        {getIsFieldRequired('GSM2', 'CAR_TEL1') && <RequiredRule message={Dict.get('GSM2') + ' ' + Dict.get('isRequired')} />}
                                        <Label text={Dict.get('GSM2')}></Label>
                                    </SimpleItem>
                                </GroupItem>

                                <GroupItem colCount={2}>
                                    <SimpleItem dataField='CAR_TC' editorType='dxNumberBox' editorOptions={{
                                        readOnly: getFieldReadOnly('TC No', 'CAR_TC'),
                                        max: 99999999999,
                                        min: 0,
                                        showSpinButtons: false
                                    }}>
                                        {getIsFieldRequired('TC No', 'CAR_TC') && <RequiredRule message={Dict.get('TC No') + ' ' + Dict.get('isRequired')} />}
                                        <Label text={Dict.get('TC No')}></Label>
                                    </SimpleItem>
                                    <SimpleItem dataField='CAR_MAIL' editorType='dxTextBox' editorOptions={addMaxLengthToEditorOptions('CARI_KART', 'CAR_MAIL', {
                                            readOnly: getFieldReadOnly('Mail', 'CAR_MAIL')
                                        })}>
                                        {getIsFieldRequired('Mail', 'CAR_MAIL') && <RequiredRule message={Dict.get('Mail') + ' ' + Dict.get('isRequired')} />}
                                        <Label text={Dict.get('Mail')}></Label>
                                    </SimpleItem>
                                </GroupItem>

                                <GroupItem colCount={2}>
                                    <SimpleItem dataField='CAR_CINSIYET' editorType="dxSelectBox" editorOptions={{
                                        readOnly: getFieldReadOnly('Cinsiyet', 'CAR_CINSIYET'),
                                        items: [{ id: 'E', value: 'Erkek' }, { id: 'K', value: 'Kadın' }],
                                        searchEnabled: true, searchMode: 'contains', displayExpr: 'value', searchExpr: 'value', valueExpr: 'id'
                                    }}>
                                        {getIsFieldRequired('Cinsiyet', 'CAR_CINSIYET') && <RequiredRule message={Dict.get('Cinsiyet') + ' ' + Dict.get('isRequired')} />}
                                        <Label text={Dict.get('Cinsiyet')} />
                                    </SimpleItem>
                                    <SimpleItem dataField='CAR_FALIYET' editorType="dxSelectBox" editorOptions={{
                                        readOnly: getFieldReadOnly('Meslek', 'CAR_FALIYET'),
                                        items: meslekSelectItems,
                                        searchEnabled: true, searchMode: 'contains', displayExpr: 'MES_ADI', searchExpr: 'MES_ADI', valueExpr: 'MES_REF'
                                    }}>
                                        {getIsFieldRequired('Meslek', 'CAR_FALIYET') && <RequiredRule message={Dict.get('Meslek') + ' ' + Dict.get('isRequired')} />}
                                        <Label text={Dict.get('Meslek')} />
                                    </SimpleItem>
                                </GroupItem>

                                <GroupItem colCount={12}>
                                    <SimpleItem colSpan={6}>
                                        <Label text={Dict.get('Doğum Tar.')} />
                                        <QuickDateOnlyBox
                                            value={formData?.CAR_DOG_TARIHI}
                                            readOnly={getFieldReadOnly('Doğum Tar.', 'CAR_DOG_TARIHI')}
                                            onValueChanged={(secilenDogumTarihi) => {
                                                if (!formDataRef.current) return;
                                                formDataRef.current.instance.updateData('CAR_DOG_TARIHI', secilenDogumTarihi);
                                                if (secilenDogumTarihi) {
                                                    const bugun = new Date();
                                                    const dogumTarihi = new Date(secilenDogumTarihi);
                                                    const yas = bugun.getFullYear() - dogumTarihi.getFullYear();
                                                    formDataRef.current.instance.updateData('CAR_YASI', yas);
                                                } else {
                                                    formDataRef.current.instance.updateData('CAR_YASI', null);
                                                }
                                                setFormDataChanged(true);
                                            }}
                                        />
                                    </SimpleItem>

                                    <SimpleItem dataField='CAR_YASI' editorType="dxNumberBox" colSpan={3} editorOptions={{
                                        readOnly: getFieldReadOnly('Yaşı', 'CAR_YASI'),
                                        onValueChanged: (e) => {
                                            if (!formDataRef.current)
                                                return;
                                            if (e.value !== undefined && e.value !== null) {
                                                const today = new Date();
                                                const birthDate = new Date(today.getFullYear() - e.value, today.getMonth(), today.getDate());
                                                formDataRef.current.instance.updateData('CAR_DOG_TARIHI', birthDate);
                                            }
                                        }
                                    }}><Label text={Dict.get('Yaşı')} /></SimpleItem>
                                    <SimpleItem dataField='CAR_DIL_REF' editorType="dxSelectBox" colSpan={3} editorOptions={{
                                        readOnly: getFieldReadOnly('Dil', 'CAR_DIL_REF'),
                                        items: query(glb.default.sabitLkp).filter(x => x.ST_TUR === 23).toArray(),
                                        searchEnabled: true, searchMode: 'contains', displayExpr: 'ST_AD', searchExpr: 'ST_AD', valueExpr: 'ST_REF'
                                    }}>
                                        {getIsFieldRequired('Dil', 'CAR_DIL_REF') && <RequiredRule message={Dict.get('Dil') + ' ' + Dict.get('isRequired')} />}
                                        <Label text={Dict.get('Dil')} />
                                    </SimpleItem>
                                </GroupItem>

                                <GroupItem>
                                    <SimpleItem dataField='CAR_ACENTA_REF' editorType='dxSelectBox' editorOptions={{
                                        readOnly: getFieldReadOnly('Acente', 'CAR_ACENTA_REF'),
                                        items: query(glb.default.sabitLkp).filter(x => x.ST_TUR === 3).toArray(),
                                        searchEnabled: true, searchMode: 'contains', displayExpr: 'ST_AD', searchExpr: 'ST_AD', valueExpr: 'ST_REF'
                                    }}>
                                        {getIsFieldRequired('Acente', 'CAR_ACENTA_REF') && <RequiredRule message={Dict.get('Acente') + ' ' + Dict.get('isRequired')} />}
                                        <Label text={Dict.get('Acente')} />
                                    </SimpleItem>
                                </GroupItem>

                                <GroupItem colCount={3}>
                                    <SimpleItem dataField='CAR_ULKE' editorType='dxSelectBox' editorOptions={{
                                        readOnly: getFieldReadOnly('Ülke', 'CAR_ULKE'),
                                        onValueChanged: ulkeSec,
                                        items: glb.default.ULKELkp,
                                        searchEnabled: true, searchMode: 'contains', displayExpr: 'ULKE_AD', searchExpr: 'ULKE_AD', valueExpr: 'ULKE_REF',
                                    }}>
                                        {getIsFieldRequired('Ülke', 'CAR_ULKE') && <RequiredRule message={Dict.get('Ülke') + ' ' + Dict.get('isRequired')} />}
                                        <Label text={Dict.get('Ülke')}></Label>
                                    </SimpleItem>
                                    <SimpleItem dataField='CAR_IL' editorType='dxSelectBox' editorOptions={{
                                        readOnly: getFieldReadOnly('İl', 'CAR_IL'),
                                        onValueChanged: sehirSec,
                                        items: query(glb.default.ILLkp).filter(x => Number(x.IL_ULKE_REF) === Number(formData?.CAR_ULKE)).toArray(),
                                        searchEnabled: true, searchMode: 'contains', displayExpr: 'IL_ADI', searchExpr: 'IL_ADI', valueExpr: 'IL_REF',
                                    }}>
                                        {getIsFieldRequired('İl', 'CAR_IL') && <RequiredRule message={Dict.get('İl') + ' ' + Dict.get('isRequired')} />}
                                        <Label text={Dict.get('İl')}></Label>
                                    </SimpleItem>
                                    <SimpleItem dataField='CAR_SEMT' editorType='dxSelectBox' editorOptions={{
                                        readOnly: getFieldReadOnly('İlçe', 'CAR_SEMT'),
                                        items: query(glb.default.ILCELkp).filter(x => Number(x.ILCE_IL_REF) === Number(formData?.CAR_IL)).toArray(),
                                        searchEnabled: true, searchMode: 'contains', displayExpr: 'ILCE_ADI', searchExpr: 'ILCE_ADI', valueExpr: 'ILCE_REF'
                                    }}>
                                        {getIsFieldRequired('İlçe', 'CAR_SEMT') && <RequiredRule message={Dict.get('İlçe') + ' ' + Dict.get('isRequired')} />}
                                        <Label text={Dict.get('İlçe')}></Label>
                                    </SimpleItem>
                                </GroupItem>

                                <GroupItem>
                                    <SimpleItem dataField='CAR_ADRES' editorType='dxTextBox' editorOptions={addMaxLengthToEditorOptions('CARI_KART', 'CAR_ADRES', {
                                            readOnly: getFieldReadOnly('Adres', 'CAR_ADRES')
                                        })}>
                                        {getIsFieldRequired('Adres', 'CAR_ADRES') && <RequiredRule message={Dict.get('Adres') + ' ' + Dict.get('isRequired')} />}
                                        <Label text={Dict.get('Adres')}></Label>
                                    </SimpleItem>
                                </GroupItem>

                                <GroupItem colCount={2}>
                                    <SimpleItem dataField='CAR_ULASIM_REF' editorType='dxSelectBox'
                                        editorOptions={{
                                            readOnly: getFieldReadOnly('Proje Adı', 'CAR_ULASIM_REF') ,
                                            items: query(glb.default.sabitLkp).filter(x => x.ST_TUR === 2).toArray(),
                                            searchEnabled: true, searchMode: 'contains', displayExpr: 'ST_AD', searchExpr: 'ST_AD', valueExpr: 'ST_REF'
                                        }}>
                                        <RequiredRule message={Dict.get('Proje Adı') + ' ' + Dict.get('isRequired')} />
                                        <Label text={Dict.get('Proje Adı')}></Label>
                                    </SimpleItem>
                                    <SimpleItem dataField='CAR_BULUSMA_REF' editorType='dxSelectBox'
                                        editorOptions={{
                                            readOnly: getFieldReadOnly('Ulaşım Şekli', 'CAR_BULUSMA_REF') ,
                                            items: query(glb.default.sabitLkp).filter(x => x.ST_TUR === 1).toArray(),
                                            searchEnabled: true, searchMode: 'contains', displayExpr: 'ST_AD', searchExpr: 'ST_AD', valueExpr: 'ST_REF'
                                        }}>
                                        <RequiredRule message={Dict.get('Ulaşım Şekli') + ' ' + Dict.get('isRequired')} />
                                        <Label text={Dict.get('Ulaşım Şekli')}></Label>
                                    </SimpleItem>
                                </GroupItem>

                                    <GroupItem cssClass="cari-reference-section">
                                        <TabbedItem cssClass="cari-form-cevap-tabs">
                                            <TabPanelOptions
                                                deferRendering={false}
                                                height={formTabsPanelH}
                                                elementAttr={{ class: 'cari-form-cevap-tabs' }}
                                            />
                                            <Tab title="Form Cevapları">
                                                <SimpleItem
                                                    dataField="FORM_CEVAPLAR"
                                                    label={{ visible: false }}
                                                    render={() => (
                                                            <DataGrid
                                                                dataSource={formCevapRows}
                                                                keyExpr="CFC_REF"
                                                                showBorders={true}
                                                                columnAutoWidth={true}
                                                                height={formCevapGridH}
                                                                noDataText="Form cevabı yok"
                                                                onRowCollapsing={(e) => {
                                                                    const key = e?.key;
                                                                    if (key == null) return;
                                                                    setFormCevapCollapsedKeys((prev) => {
                                                                        const next = new Set(prev);
                                                                        next.add(key);
                                                                        return next;
                                                                    });
                                                                }}
                                                                onRowExpanding={(e) => {
                                                                    const key = e?.key;
                                                                    if (key == null) return;
                                                                    setFormCevapCollapsedKeys((prev) => {
                                                                        if (!prev.has(key)) return prev;
                                                                        const next = new Set(prev);
                                                                        next.delete(key);
                                                                        return next;
                                                                    });
                                                                }}
                                                            >
                                                                <Grouping autoExpandAll={true} />
                                                                <GroupPanel visible={false} />
                                                                <Column
                                                                    dataField="CFG_GELIS_NO"
                                                                    caption="Geliş"
                                                                    groupIndex={0}
                                                                    sortOrder="desc"
                                                                    sortIndex={0}
                                                                    groupCellRender={(cell) => {
                                                                        const row = cell?.data?.items?.[0] || cell?.data?.collapsedItems?.[0];
                                                                        const gelis = formGelisByRef.get(String(row?.CFC_GELIS_REF ?? ''))
                                                                            || formGelisByRef.get(`no:${row?.CFG_GELIS_NO ?? cell?.value ?? ''}`);
                                                                        const label = row?.CFG_GELIS_LABEL || `Geliş ${cell?.value ?? ''}`;
                                                                        if (!reklamGorseliUrl(gelis)) return label;
                                                                        return (
                                                                            <button
                                                                                type="button"
                                                                                className="cari-reklam-gorsel-link"
                                                                                title="Reklam görselini göster"
                                                                                onMouseEnter={() => setReklamGorselGelis(gelis)}
                                                                                onClick={(event) => {
                                                                                    event.stopPropagation();
                                                                                    setReklamGorselGelis(gelis);
                                                                                }}
                                                                            >
                                                                                {label} <span aria-hidden="true">🖼️</span>
                                                                            </button>
                                                                        );
                                                                    }}
                                                                />
                                                                <Column dataField="CFC_SORU_NO" caption="No" width={50} />
                                                                <Column dataField="CFC_SORU" caption="Soru" />
                                                                <Column dataField="CFC_CEVAP" caption="Cevap" />
                                                                <Column dataField="CFC_KAYNAK" caption="Kaynak" width={90} />
                                                            </DataGrid>
                                                    )}
                                                />
                                            </Tab>
                                            <Tab title="Form Bilgileri">
                                                <SimpleItem
                                                    label={{ visible: false }}
                                                    render={() => (
                                                        <div style={{
                                                            marginBottom: 8,
                                                            fontWeight: 600,
                                                            fontSize: 14,
                                                        }}>
                                                            Geliş Sayısı: {Number(formData?.CAR_GEL_SAY) || 0}
                                                        </div>
                                                    )}
                                                />
                                                <SimpleItem
                                                    dataField="FORM_GELISLER"
                                                    label={{ visible: false }}
                                                    render={() => (
                                                            <DataGrid
                                                                dataSource={formGelisRows}
                                                                keyExpr="CFG_REF"
                                                                showBorders={true}
                                                                columnAutoWidth={true}
                                                                height={formGelisGridH}
                                                                noDataText="Form gelişi yok"
                                                            >
                                                                <Column
                                                                    dataField="CFG_GELIS_NO"
                                                                    caption="Geliş"
                                                                    width={70}
                                                                    sortOrder="desc"
                                                                    sortIndex={0}
                                                                />
                                                                <Column
                                                                    dataField="CFG_GIR_TAR"
                                                                    caption="Giriş Tar."
                                                                    dataType="datetime"
                                                                    format="dd.MM.yyyy HH:mm"
                                                                    width={130}
                                                                />
                                                                <Column
                                                                    dataField="CFG_META_TAR"
                                                                    caption="Meta Tarih"
                                                                    dataType="datetime"
                                                                    format="dd.MM.yyyy HH:mm"
                                                                    width={130}
                                                                />
                                                                <Column dataField="CFG_CAMPAIGN" caption="Kampanya" />
                                                                <Column dataField="CFG_ACCOUNT" caption="Hesap" />
                                                                <Column dataField="CFG_FORM_NAME" caption="Form" />
                                                                <Column dataField="CFG_FORM_ID" caption="Form ID" width={100} />
                                                                <Column dataField="CFG_PAGE" caption="Sayfa" />
                                                                <Column dataField="CFG_EXTERNAL_LEAD" caption="Ext. Lead" width={100} />
                                                                <Column dataField="CFG_LEAD_ID" caption="Lead Id" width={120} />
                                                                <Column dataField="CFG_KAYNAK" caption="Kaynak" width={80} />
                                                            </DataGrid>
                                                    )}
                                                />
                                            </Tab>
                                        </TabbedItem>
                                        <Popup
                                            visible={Boolean(reklamGorseliUrl(reklamGorselGelis))}
                                            onHiding={() => setReklamGorselGelis(null)}
                                            title={reklamGorselGelis?.CFG_AD_NAME || 'Reklam Görseli'}
                                            width="min(92vw, 760px)"
                                            height="min(88vh, 760px)"
                                            className="cari-reklam-gorsel-popup"
                                        >
                                            <div className="cari-reklam-gorsel-popup__content">
                                                <img
                                                    src={reklamGorseliUrl(reklamGorselGelis)}
                                                    alt={reklamGorselGelis?.CFG_AD_NAME || 'Reklam görseli'}
                                                />
                                            </div>
                                        </Popup>
                                        <SimpleItem dataField="CAR_REF_VAR" visible={false} editorType="dxCheckBox">
                                            {getIsFieldRequired('Ref.Var', 'CAR_REF_VAR') && <RequiredRule message={Dict.get('Ref.Var') + ' ' + Dict.get('isRequired')} />}
                                        </SimpleItem>
                                        <SimpleItem render={() => (
                                            <div style={{
                                                marginTop: 6,
                                                marginBottom: 4,
                                                padding: '10px 15px',
                                                background: 'var(--dx-color-bg-secondary, #f8f9fa)',
                                                borderBottom: '2px solid var(--dx-color-border, #dee2e6)',
                                                borderRadius: '4px 4px 0 0'
                                            }}>
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    flexWrap: 'wrap',
                                                    gap: 12
                                                }}>
                                                    <h3 style={{
                                                        margin: 0,
                                                        fontSize: 16,
                                                        fontWeight: 600,
                                                        color: 'var(--dx-color-text, #212529)',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 8
                                                    }}>
                                                        <span style={{ fontSize: 18 }}>🔗</span>
                                                        {Dict.get('Referans Bilgileri')}
                                                    </h3>
                                                    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
                                                        <Button
                                                            text={props.ops.ptype === 'insert' ? "Referans Cari Ara" : "SonRef Cari Ara"}
                                                            type="default"
                                                            stylingMode="outlined"
                                                            icon="search"
                                                            onClick={formAra_click}
                                                        />
                                                        <Button
                                                            text="Referans Liste"
                                                            type="default"
                                                            stylingMode="outlined"
                                                            icon="menu"
                                                            disabled={!formData?.CAR_REF || Number(formData.CAR_REF) <= 0}
                                                            visible={props.ops.ptype !== 'insert'}
                                                            onClick={openReferansListe}
                                                        />
                                                        {pendingReferenceApproval && (
                                                            <Button
                                                                text={`Onaya Gönder: ${pendingReferenceApproval.CAR_ADSOY}`}
                                                                type="danger"
                                                                icon="check"
                                                                disabled={referenceApprovalSending}
                                                                onClick={sendReferenceApproval}
                                                            />
                                                        )}
                                                        <CheckBox
                                                            text={Dict.get('Ref.Var')}
                                                            value={!!formData?.CAR_REF_VAR}
                                                            readOnly={getFieldReadOnly('Ref.Var', 'CAR_REF_VAR')}
                                                            elementAttr={{ style: 'margin-left: 8px;' }}
                                                            onValueChanged={(e) => refVarCheckboxChanged(e.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )} />
                                        <GroupItem colCount={2}>
                                            <GroupItem colCount={1}>
                                                <SimpleItem
                                                    label={{ text: 'İlk ref' }}
                                                    render={() => {
                                                        const ilkText = formData?.CAR_ILK_REF_ADI || '';
                                                        const ilkRefId = formData?.CAR_ILK_REF_C_REF;
                                                        const valIlk = { fontWeight: 700, color: '#b71c1c' };
                                                        return ilkText ? (
                                                            <span
                                                                role="button"
                                                                tabIndex={0}
                                                                className="pointer"
                                                                style={{ ...valIlk, textDecoration: 'underline', cursor: 'pointer' }}
                                                                onClick={() => openRefCariKart(ilkRefId)}
                                                                onKeyDown={(ev) => { if (ev.key === 'Enter') openRefCariKart(ilkRefId); }}
                                                            >{ilkText}</span>
                                                        ) : <span style={valIlk}>-</span>;
                                                    }}
                                                />
                                                <SimpleItem
                                                    label={{ text: Dict.get('Ulaşım Şekli') }}
                                                    render={() => {
                                                        const ilkUlasim = formData?.CAR_ILK_REF_ULASIM || '-';
                                                        return <span style={{ fontWeight: 700, color: '#b71c1c' }}>{ilkUlasim}</span>;
                                                    }}
                                                />
                                            </GroupItem>
                                            <GroupItem colCount={1}>
                                                <SimpleItem
                                                    label={{ text: 'Son ref' }}
                                                    render={() => {
                                                        const sonRefAdi = formData?.CAR_SON_REF_ADI || '';
                                                        const sonRefId = formData?.CAR_SON_REF_C_REF;
                                                        const valSon = { fontWeight: 700, color: '#1b5e20' };
                                                        return sonRefAdi ? (
                                                            <span
                                                                role="button"
                                                                tabIndex={0}
                                                                className="pointer"
                                                                style={{ ...valSon, textDecoration: 'underline', cursor: 'pointer' }}
                                                                onClick={() => openRefCariKart(sonRefId)}
                                                                onKeyDown={(ev) => { if (ev.key === 'Enter') openRefCariKart(sonRefId); }}
                                                            >{sonRefAdi}</span>
                                                        ) : <span style={valSon}>-</span>;
                                                    }}
                                                />
                                                <SimpleItem
                                                    label={{ text: Dict.get('Ulaşım Şekli') }}
                                                    render={() => {
                                                        const sonUlasim = formData?.CAR_SON_REF_ULASIM || '-';
                                                        return <span style={{ fontWeight: 700, color: '#1b5e20' }}>{sonUlasim}</span>;
                                                    }}
                                                />
                                            </GroupItem>
                                        </GroupItem>
                                    </GroupItem>

                                {/* Anemnez / Sağlık Bilgileri Inline (component kaldırıldı çünkü DevExtreme Form children parse etmiyor) */}
                                <GroupItem cssClass="cari-anemnez-section">
                                    <SimpleItem render={() => (
                                        <div style={{
                                            padding: '10px 15px',
                                            background: 'var(--dx-color-bg-secondary, #f8f9fa)',
                                            borderBottom: '2px solid var(--dx-color-border, #dee2e6)',
                                            margin: '10px 0',
                                            borderRadius: '4px 4px 0 0'
                                        }}>
                                            <h3 style={{
                                                margin: 0,
                                                fontSize: '16px',
                                                fontWeight: 600,
                                                color: 'var(--dx-color-text, #212529)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px'
                                            }}>
                                                <span style={{ fontSize: '18px' }}>🏥</span>
                                                {Dict.get('Anemnez / Sağlık Bilgileri')}
                                            </h3>
                                        </div>
                                    )} />
                                    <GroupItem colCount={2}>
                                        <SimpleItem dataField='CAR_KRON_HAS' editorType='dxTextArea'
                                            label={{ text: 'Kronik Hastalıklar' }}
                                            editorOptions={{ readOnly: getFieldReadOnly('Kronik Hast.', 'CAR_KRON_HAS'), minHeight: '20px', autoResizeEnabled: true }} />
                                        <SimpleItem dataField='CAR_KUL_ILAC' editorType='dxTextArea'
                                            label={{ text: 'Kullandığı İlaçlar' }}
                                            editorOptions={{ readOnly: getFieldReadOnly('Kullan.İlaç', 'CAR_KUL_ILAC'), minHeight: '20px', autoResizeEnabled: true }} />
                                    </GroupItem>
                                    <GroupItem colCount={2}>
                                        <SimpleItem dataField='CAR_AML_OPS' editorType='dxTextArea'
                                            label={{ text: 'Geçirdiği Ameliyatlar / Operasyonlar' }}
                                            editorOptions={{ readOnly: getFieldReadOnly('Ameliyat/Geç.Ops.', 'CAR_AML_OPS'), minHeight: '20px', autoResizeEnabled: true }} />
                                        <SimpleItem dataField='CAR_OZ_GECMIS' editorType='dxTextArea'
                                            label={{ text: 'Sigara / Alkol / Madde Kullanımı' }}
                                            editorOptions={{ readOnly: getFieldReadOnly('Sgr/Alkol/Madde', 'CAR_OZ_GECMIS'), minHeight: '20px', autoResizeEnabled: true }} />
                                    </GroupItem>
                                    <GroupItem colCount={2}>
                                        <SimpleItem dataField='CAR_SAC_DER_HAS' editorType='dxTextArea'
                                            label={{ text: 'Saç Derisi Hastalıkları' }}
                                            editorOptions={{ readOnly: getFieldReadOnly('Saç Deri.Hast.', 'CAR_SAC_DER_HAS'), minHeight: '20px', autoResizeEnabled: true }} />
                                        <SimpleItem dataField='CAR_SAC_ANALIZ' editorType='dxTextArea'
                                            label={{ text: Dict.get('Saç Analiz') }}
                                            editorOptions={{ readOnly: getFieldReadOnly('Saç Analiz', 'CAR_SAC_ANALIZ'), minHeight: '20px', autoResizeEnabled: true }} />
                                    </GroupItem>
                                    <GroupItem colCount={12}>
                                        <SimpleItem colSpan={3} cssClass="cari-eski-sac-ekim" dataField='CAR_DONCE_SAC_EKIM_VAR' editorType='dxCheckBox' editorOptions={{ readOnly: getFieldReadOnly('Eski Saç Ekim Var?', 'CAR_DONCE_SAC_EKIM_VAR') }}>
                                            <Label text={Dict.get('Eski Saç Ekim Var?')} />
                                        </SimpleItem>
                                        <SimpleItem
                                            colSpan={9}
                                            dataField='CAR_ESKISACZMN'
                                            editorType='dxTextBox'
                                            editorOptions={{
                                                readOnly: getFieldReadOnly('Açıklama', 'CAR_ESKISACZMN'),
                                                maxLength: 50,
                                            }}
                                        >
                                            <Label text={Dict.get('Açıklama')} />
                                            {(formData?.CAR_DONCE_SAC_EKIM_VAR === true) && <RequiredRule message={Dict.get('Açıklama') + ' ' + Dict.get('isRequired')} />}
                                        </SimpleItem>
                                    </GroupItem>
                                    <GroupItem colCount={12}>
                                        <SimpleItem colSpan={3} dataField='CAR_KISI_UYAR' editorType='dxCheckBox' editorOptions={{ readOnly: getFieldReadOnly('UYAR', 'CAR_KISI_UYAR') }}>
                                            <Label text={Dict.get('UYAR')} />
                                        </SimpleItem>
                                        <SimpleItem colSpan={9} dataField='CAR_ACK' editorType='dxTextArea' label={{ text: Dict.get('Açıklama') }}
                                            editorOptions={{ readOnly: getFieldReadOnly('Açıklama', 'CAR_ACK'), height: 56, autoResizeEnabled: true }} />
                                    </GroupItem>
                                    <GroupItem colCount={12}>
                                        <SimpleItem colSpan={12} dataField='CAR_NOT' editorType='dxTextArea' label={{ text: Dict.get('Yetkili Açıklama') }}
                                            editorOptions={{
                                                readOnly: getFieldReadOnly('Yetkili Açıklama', 'CAR_NOT'),
                                                keepEditable: isCariGeneralAuthUser(),
                                                height: 70,
                                                autoResizeEnabled: true,
                                                onKeyDown: (e) => {
                                                    if (e?.event?.key !== 'Enter') return;
                                                    e.event.preventDefault();
                                                    const liveText = typeof e?.event?.target?.value === 'string'
                                                        ? e.event.target.value
                                                        : (e.component.option('value') || '');
                                                    const nextValue = appendYetkiliTimestampToLastLine(liveText) + '\n';
                                                    if (e?.event?.target) {
                                                        e.event.target.value = nextValue;
                                                    }
                                                    formDataRef.current?.instance?.updateData('CAR_NOT', nextValue);
                                                    setFormDataChanged(true);
                                                },
                                                onFocusOut: (e) => {
                                                    const currentRaw = typeof e?.event?.target?.value === 'string'
                                                        ? e.event.target.value
                                                        : (e.component.option('value') || '');
                                                    const cur = String(currentRaw || '');
                                                    if (!cur.trim()) return;
                                                    const nextValue = appendYetkiliTimestampToLastLine(cur);
                                                    if (nextValue !== currentRaw) {
                                                        if (e?.event?.target) {
                                                            e.event.target.value = nextValue;
                                                        }
                                                        formDataRef.current?.instance?.updateData('CAR_NOT', nextValue);
                                                        setFormDataChanged(true);
                                                    }
                                                }
                                            }} />
                                    </GroupItem>
                                    <TabbedItem>
                                        <TabPanelOptions deferRendering={false} />
                                        <Tab title={Dict.get('Sağlık Detay')}>
                                            <GroupItem colCount={2}>
                                                <SimpleItem dataField='CAR_HAMILE_RISK' editorType='dxCheckBox' editorOptions={{ readOnly: getFieldReadOnly('Hamile.Risk', 'CAR_HAMILE_RISK') }}><Label text="Hamilelik Riski" /></SimpleItem>
                                                <SimpleItem dataField='CAR_EMZIRIYOR' editorType='dxCheckBox' editorOptions={{ readOnly: getFieldReadOnly('Emziriyor', 'CAR_EMZIRIYOR') }}><Label text={Dict.get('Emziriyor')} /></SimpleItem>
                                                <SimpleItem dataField='CAR_SEKER_HST' editorType='dxCheckBox' editorOptions={{ readOnly: getFieldReadOnly('Şekr.Hst.', 'CAR_SEKER_HST') }}><Label text="Şeker Hastalığı" /></SimpleItem>
                                                <SimpleItem dataField='CAR_SIS_ENFK' editorType='dxCheckBox' editorOptions={{ readOnly: getFieldReadOnly('Sis.Enf.', 'CAR_SIS_ENFK') }}><Label text="Sistemik Enfeksiyon" /></SimpleItem>
                                                <SimpleItem dataField='CAR_UYG_KOZM' editorType='dxCheckBox' editorOptions={{ readOnly: getFieldReadOnly('Kozm.Kul.', 'CAR_UYG_KOZM') }}><Label text="Kozmetik Ürün Kullanımı" /></SimpleItem>
                                                <SimpleItem dataField='CAR_UYG_ALN_ENFK' editorType='dxCheckBox' editorOptions={{ readOnly: getFieldReadOnly('Alan.Enf.', 'CAR_UYG_ALN_ENFK') }}><Label text="Uygulama Alanında Enfeksiyon" /></SimpleItem>
                                                <SimpleItem dataField='CAR_ILAC_KUL' editorType='dxCheckBox' editorOptions={{ readOnly: getFieldReadOnly('\u0130laç Kul.', 'CAR_ILAC_KUL') }}><Label text="Düzenli İlaç Kullanımı" /></SimpleItem>
                                                <SimpleItem dataField='CAR_KAN_YATKN' editorType='dxCheckBox' editorOptions={{ readOnly: getFieldReadOnly('Kanama.Yat.', 'CAR_KAN_YATKN') }}><Label text="Kanama Yatkınlığı" /></SimpleItem>
                                                <SimpleItem dataField='CAR_ASP_KANSU_KUL' editorType='dxCheckBox' editorOptions={{ readOnly: getFieldReadOnly('Aspr.Kan Su.', 'CAR_ASP_KANSU_KUL') }}><Label text="Aspirin / Kan Sulandırıcı Kullanımı" /></SimpleItem>
                                                <SimpleItem dataField='CAR_HBS_HCV' editorType='dxCheckBox' editorOptions={{ readOnly: getFieldReadOnly('HBsAg,HCV', 'CAR_HBS_HCV') }}><Label text="Hepatit B / Hepatit C" /></SimpleItem>
                                            </GroupItem>
                                        </Tab>
                                        <Tab title={Dict.get('Dökülme Tipi')}>
                                            <GroupItem colCount={2}>
                                                {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14].map((idx) => (
                                                    <GroupItem key={`dt-${idx}`} colCount={5}>
                                                        <SimpleItem colSpan={1} dataField={`DT${String(idx + 1).padStart(2, '0')}`} editorType='dxCheckBox' label={{ visible: false }} />
                                                        <SimpleItem colSpan={4}>
                                                            <img src={process.env.PUBLIC_URL + `/media/dokulme_tipi/${idx}.png`} alt="" style={{ marginLeft: '10px', height: '60px', width: '60px' }} loading="lazy" />
                                                        </SimpleItem>
                                                    </GroupItem>
                                                ))}
                                            </GroupItem>
                                        </Tab>
                                    </TabbedItem>
                                </GroupItem>

                            </GroupItem>

                            <GroupItem colSpan={inTabMode ? 6 : 7} cssClass="custom-group-item">
                                <CariAramaPanel
                                    carRef={formData.CAR_REF ?? props.ops?.CAR_REF}
                                    carKey={USE_CARI_MODEL_STORE ? (carKeyRef.current ?? formData.CAR_REF) : null}
                                    cariAramaList={formData.cariAramaList || []}
                                    deferHeavyLoads={true}
                                    onListChange={(newList) => {
                                        if (!isMountedRef.current) return;
                                        if (USE_CARI_MODEL_STORE && carKeyRef.current != null) {
                                            cariModelStore.setCariAramaList(carKeyRef.current, newList);
                                        }
                                        setFormData(prev => ({ ...prev, cariAramaList: newList }));
                                    }}
                                    formData={formData}
                                    isNewRecord={!cariKayitliMi(formData.CAR_REF ?? props.ops?.CAR_REF)}
                                />
                            </GroupItem>
                        </GroupItem>
                    </Form>
                </ScrollView>
                )}

                {!hideRedundantTabsWhenSatis && inTabMode && loadedInnerTabs.has('islem') && (
                    <div style={{ flex: 1, minHeight: 400, display: activeInnerTab === 'islem' ? 'block' : 'none' }}>
                        <IslemGirPanel
                            carRef={formData?.CAR_REF}
                            carAdSoy={formData?.CAR_ADSOY}
                            formShow={true}
                            embedded={true}
                            refreshToken={innerRefreshToken}
                            onFormKapandi={() => {}}
                        />
                    </div>
                )}

                {inTabMode && loadedInnerTabs.has('satis') && (
                    <div id="cari-satis-embedded-host" style={{ flex: 1, minHeight: 400, position: 'relative', display: activeInnerTab === 'satis' ? 'block' : 'none' }}>
                        <Carisatis
                            formShow={true}
                            embedded={true}
                            popupContainer="#cari-satis-embedded-host"
                            refreshToken={innerRefreshToken}
                            ops={{ CAR_REF: formData?.CAR_REF, CAR_ADSOY: formData?.CAR_ADSOY, CAR_TEL1: formData?.CAR_TEL1, CAR_GSM: formData?.CAR_GSM, CAR_ARA_KUL_REF: formData?.CAR_ARA_KUL_REF, BENZER_VAR: formData?.BENZER_VAR, FORM_GELISLER: formData?.FORM_GELISLER }}
                            onFormKapandi={() => {}}
                            onBenzerCariClick={(clickedCari) => {
                                const newOps = {
                                    CAR_REF: clickedCari.CAR_REF,
                                    ap: 'v',
                                    ptype: 'update',
                                    formReadOnly: formReadOnly,
                                    crud: crud
                                };
                                getFormData(newOps);
                            }}
                        />
                    </div>
                )}

                {!hideRedundantTabsWhenSatis && inTabMode && loadedInnerTabs.has('resim') && (
                    <div style={{ flex: 1, minHeight: 400, display: activeInnerTab === 'resim' ? 'block' : 'none' }}>
                        <ResimGirPanel
                            carRef={formData?.CAR_REF}
                            carAdSoy={formData?.CAR_ADSOY}
                            formShow={true}
                            embedded={true}
                            refreshToken={innerRefreshToken}
                            onFormKapandi={() => {}}
                        />
                    </div>
                )}

                {!hideRedundantTabsWhenSatis && inTabMode && loadedInnerTabs.has('ekim') && (
                    <div style={{ flex: 1, minHeight: 400, display: activeInnerTab === 'ekim' ? 'block' : 'none' }}>
                        <EkimKanalAlimGirPanel
                            carRef={formData?.CAR_REF}
                            carAdSoy={formData?.CAR_ADSOY}
                            formShow={true}
                            embedded={true}
                            refreshToken={innerRefreshToken}
                            onFormKapandi={() => {}}
                        />
                    </div>
                )}

                {!hideRedundantTabsWhenSatis && inTabMode && loadedInnerTabs.has('para') && (
                    <div style={{ flex: 1, minHeight: 400, display: activeInnerTab === 'para' ? 'block' : 'none' }}>
                        <ParaGirPanel
                            carRef={formData?.CAR_REF}
                            carAdSoy={formData?.CAR_ADSOY}
                            formShow={true}
                            embedded={true}
                            refreshToken={innerRefreshToken}
                            onFormKapandi={() => {}}
                        />
                    </div>
                )}

                {inTabMode && loadedInnerTabs.has('whatsapp') && (
                    <div style={{ flex: 1, minHeight: 400, display: activeInnerTab === 'whatsapp' ? 'block' : 'none' }}>
                        <WhatsAppConversationsPanel
                            carRef={formData?.CAR_REF}
                            phone={formData?.CAR_TEL1 || formData?.CAR_GSM}
                            leadId={formData?.CAR_SS_LEAD_ID}
                            visible={activeInnerTab === 'whatsapp'}
                        />
                    </div>
                )}
            </div>

            {/* Yazdır Popup */}
            <Popup id="yazForm" width={'100%'} height={'100vh'}
                visible={showYazdir} shading={false} dragEnabled={false} onHiding={yazFormHiding}
                close_ClickOnOutsideClick={true} popupOptions={{ animation: null }} showCloseButton={false}
                toolbarItems={
                    [
                        {
                            location: 'center',
                            widget: 'dxTextBox',
                            options: {
                                text: Dict.get(screen.EKR_ETIKET + ' Yazdır'),
                                readOnly: true,
                                width: 200,
                                height: 30,
                                textAlign: 'center'
                            }
                        },
                        {
                            location: 'after', widget: 'dxButton', options: {
                                text: Dict.get('Çıkış'), type: 'default', onClick: yazFormHiding,
                                visible: true, hint: Dict.get('Çıkış'), icon: 'close'
                            }
                        }
                    ]
                }>
                <CariYazdir lang={yazdirLang} fdata={formData} resimler={formData.cariResimList} />
                <Position my={'center'} at={'center'} of={window} />
            </Popup>

            {/* Cari Ara Popup */}
            <Popup id="araForm" width={'90%'} height={'70%'}
                visible={showAra} shading={false} dragEnabled={false} onHiding={araFormHiding}
                close_ClickOnOutsideClick={true} popupOptions={{ animation: null }} showCloseButton={false}
                toolbarItems={
                    [
                        {
                            location: 'center',
                            widget: 'dxTextBox',
                            options: {
                                text: Dict.get('Cari Ara'),
                                readOnly: true,
                                width: 200,
                                height: 30,
                                textAlign: 'center'
                            }
                        },
                        {
                            location: 'after', widget: 'dxButton', options: {
                                text: Dict.get('Çıkış'), type: 'default', onClick: araFormHiding,
                                visible: true, hint: Dict.get('Çıkış'), icon: 'close'
                            }
                        }
                    ]
                }>
                <CariAra onAraSecildi={async (e) => {
                    if (!(e && e.CAR_ADSOY) || !formDataRef.current?.instance) return;
                    const form = formDataRef.current.instance;
                    const currentFormData = form.option('formData') || {};
                    if (!isCariGeneralAuthUser()) {
                        if (!(Number(currentFormData.CAR_REF) > 0)) {
                            notify('Referans değişikliğini onaya göndermek için önce cari kaydını kaydedin.', 'warning', 3500);
                            araFormHiding();
                            return;
                        }
                        setPendingReferenceApproval(e);
                        notify('Referans değişikliği yönetici onayı gerektiriyor. Referans Bilgileri bölümündeki Onaya Gönder düğmesini kullanın.', 'warning', 4500);
                        araFormHiding();
                        return;
                    }
                    setPendingReferenceApproval(null);
                    const hasLockedFirstReference = Number(currentFormData.CAR_ILK_REF_C_REF || currentFormData.CAR_ILK_REF || 0) > 0;

                    // Son referans: arama popup'tan seçilen cari
                    form.updateData('CAR_REF_C_REF', e.CAR_REF);
                    let sonRefAd = e.CAR_ADSOY;
                    if (e.ATANAN_KULLANICI) sonRefAd += ` (${e.ATANAN_KULLANICI})`;
                    form.updateData('CAR_SON_REF_C_REF', e.CAR_REF);
                    form.updateData('CAR_SON_REF_ADI', sonRefAd);
                    form.updateData('CARI_REFERANS_ADI', sonRefAd);

                    const sonRefUlasim = (query(glb.default.sabitLkp).filter(x => x.ST_TUR === 1 && Number(x.ST_REF) === Number(e.CAR_BULUSMA_REF)).toArray()[0] || {}).ST_AD || null;
                    form.updateData('CAR_SON_REF_ULASIM', sonRefUlasim);

                    // İlk ref: CAR_REF_C_REF zincirinin kökü (A→B→C: A için C); kayıt öncesi ilk adım için CAR_REF_C_REF parametresi
                    try {
                        if (hasLockedFirstReference) throw new Error('FIRST_REFERENCE_LOCKED');
                        const musteriRef = Number(form.option('formData')?.CAR_REF || 0);
                        const secilenRef = Number(e.CAR_REF || 0);
                        if (musteriRef > 0 && secilenRef > 0) {
                            const ilkRes = await Axios.get(
                                `${process.env.REACT_APP_BACKEND_SERVER}CARI_KART/refilkuc?CAR_REF=${musteriRef}&CAR_REF_C_REF=${secilenRef}`
                            );
                            const ilk = ilkRes?.data || {};
                            const ilkId = Number(ilk.CAR_ILK_REF_C_REF || 0);
                            if (ilkId > 0) {
                                form.updateData('CAR_ILK_REF_C_REF', ilk.CAR_ILK_REF_C_REF);
                                form.updateData('CAR_ILK_REF', ilk.CAR_ILK_REF_C_REF);
                                form.updateData('CAR_ILK_REF_ADI', ilk.CAR_ILK_REF_ADI ?? null);
                                form.updateData('CAR_ILK_REF_ULASIM', ilk.CAR_ILK_REF_ULASIM ?? null);
                            } else {
                                form.updateData('CAR_ILK_REF_C_REF', e.CAR_REF);
                                form.updateData('CAR_ILK_REF', e.CAR_REF);
                                form.updateData('CAR_ILK_REF_ADI', sonRefAd);
                                form.updateData('CAR_ILK_REF_ULASIM', sonRefUlasim);
                            }
                        } else {
                            form.updateData('CAR_ILK_REF_C_REF', e.CAR_REF);
                            form.updateData('CAR_ILK_REF', e.CAR_REF);
                            form.updateData('CAR_ILK_REF_ADI', sonRefAd);
                            form.updateData('CAR_ILK_REF_ULASIM', sonRefUlasim);
                        }
                    } catch (err) {
                        if (!hasLockedFirstReference && err?.message !== 'FIRST_REFERENCE_LOCKED') {
                            form.updateData('CAR_ILK_REF_C_REF', e.CAR_REF);
                            form.updateData('CAR_ILK_REF', e.CAR_REF);
                            form.updateData('CAR_ILK_REF_ADI', sonRefAd);
                            form.updateData('CAR_ILK_REF_ULASIM', sonRefUlasim);
                        }
                    }

                    // Form instance güncellendi; React state + MobX model senkron (kayıtta CAR_REF_C_REF DB'ye gider)
                    const fd = form.option('formData') || {};
                    setFormData((prev) => ({ ...(prev || {}), ...fd }));
                    if (USE_CARI_MODEL_STORE && carKeyRef.current != null) {
                        cariModelStore.updateCarikart(carKeyRef.current, {
                            CAR_REF_C_REF: fd.CAR_REF_C_REF,
                            CAR_SON_REF_C_REF: fd.CAR_SON_REF_C_REF,
                            CAR_SON_REF_ADI: fd.CAR_SON_REF_ADI,
                            CAR_SON_REF_ULASIM: fd.CAR_SON_REF_ULASIM,
                            CAR_ILK_REF: fd.CAR_ILK_REF,
                            CAR_ILK_REF_C_REF: fd.CAR_ILK_REF_C_REF,
                            CAR_ILK_REF_ADI: fd.CAR_ILK_REF_ADI,
                            CAR_ILK_REF_ULASIM: fd.CAR_ILK_REF_ULASIM,
                            CARI_REFERANS_ADI: fd.CARI_REFERANS_ADI
                        });
                    }

                    setFormDataChanged(true);
                    araFormHiding();
                }} />
                <Position my={'center'} at={'center'} of={window} />
            </Popup>

            <Popup
                visible={showTelDupPopup}
                onHiding={() => { setShowTelDupPopup(false); }}
                dragEnabled={false}
                showCloseButton={true}
                width={720}
                height={420}
                title="Telefon uyarısı"
                shading={true}
                toolbarItems={[
                    {
                        location: 'after',
                        widget: 'dxButton',
                        options: {
                            text: Dict.get('Tamam') || 'Tamam',
                            type: 'default',
                            onClick: () => setShowTelDupPopup(false)
                        }
                    }
                ]}
            >
                <div style={{ marginBottom: 10 }}>
                    <div style={{ fontWeight: 600 }}>Bu telefon numarası başka bir cari kartta da kullanılıyor.</div>
                    <div style={{ marginTop: 4 }}>
                        Kişinin adı soyadı farklıysa aile bireyi olarak yeni kayıt açabilirsiniz; bu uyarı kaydı engellemez.
                    </div>
                </div>
                <DataGrid
                    dataSource={telDupRows}
                    keyExpr="CAR_REF"
                    showBorders={true}
                    height={280}
                    columnAutoWidth={true}
                    hoverStateEnabled={true}
                    focusedRowEnabled={true}
                    onRowClick={(e) => {
                        const id = Number(e?.data?.CAR_REF || 0);
                        if (id > 0) openRefCariKart(id);
                    }}
                    onRowDblClick={(e) => {
                        const id = Number(e?.data?.CAR_REF || 0);
                        if (id > 0) {
                            openRefCariKart(id);
                        }
                    }}
                >
                    <Scrolling mode="standard" useNative={true} />
                    <Column
                        dataField="CAR_ADSOY"
                        caption={Dict.get('Ad Soyad')}
                        cellRender={(cell) => (
                            <u
                                className="pointer"
                                style={{ cursor: 'pointer', color: 'var(--dx-color-primary, #1976d2)' }}
                                onClick={(ev) => {
                                    ev?.preventDefault?.();
                                    ev?.stopPropagation?.();
                                    const id = Number(cell?.data?.CAR_REF || 0);
                                    if (id > 0) {
                                        openRefCariKart(id);
                                    }
                                }}
                            >
                                {cell?.displayValue || cell?.data?.CAR_ADSOY || ''}
                            </u>
                        )}
                    />
                    <Column dataField="CAR_GSM" caption={Dict.get('GSM1')} />
                    <Column dataField="DATA_SAHIBI" caption={Dict.get('Data Sahibi')} />
                    <Column dataField="CAR_TEL1" caption={Dict.get('GSM2')} />
                    <Column dataField="CAR_MAIL" caption={Dict.get('Mail')} />
                </DataGrid>
                <Position my="center" at="center" of={window} />
            </Popup>

            <Popup
                visible={showReferansListe}
                onHiding={() => { setShowReferansListe(false); }}
                dragEnabled={false}
                showCloseButton={true}
                width={920}
                height={560}
                title={`Referans listesi${formData?.CAR_ADSOY ? ` — ${formData.CAR_ADSOY}` : ''}`}
                shading={true}
                toolbarItems={[
                    {
                        location: 'after',
                        widget: 'dxButton',
                        options: {
                            text: Dict.get('Çıkış'),
                            type: 'default',
                            icon: 'close',
                            onClick: () => setShowReferansListe(false)
                        }
                    }
                ]}
            >
                <DataGrid
                    dataSource={referansListeRows}
                    keyExpr="ROW_KEY"
                    loading={referansListeLoading}
                    showBorders={true}
                    height={460}
                    columnAutoWidth={true}
                    allowColumnResizing={true}
                    hoverStateEnabled={true}
                    focusedRowEnabled={true}
                    repaintChangesOnly={true}
                    onRowDblClick={(e) => {
                        const d = e?.data;
                        const sag = Number(d?.SAG_CAR_REF);
                        const sol = Number(d?.SOL_CAR_REF);
                        const id = (Number.isFinite(sag) && sag > 0) ? sag : sol;
                        if (id > 0) {
                            openRefCariKart(id);
                            setShowReferansListe(false);
                        }
                    }}
                >
                    <LoadPanel enabled={referansListeLoading} />
                    <FilterRow visible={true} applyFilter="auto" />
                    <Scrolling mode="standard" useNative={true} />
                    <Column dataField="SIRA" caption="#" width={48} />
                    <Column dataField="SOL_CAR_ADSOY" caption="Cari (satır)" />
                    <Column dataField="SOL_ATANAN_KUL_ADI" caption="Atanan" />
                    <Column dataField="SOL_ULASIM_SEKLI" caption="Ulaşım" />
                    <Column dataField="YAN_SECIM" caption="Yan seçim" width={88} />
                    <Column dataField="SAG_CAR_ADSOY" caption="Son / ilk ref cari" />
                    <Column dataField="SAG_ATANAN_KUL_ADI" caption="Yan atanan" />
                    <Column dataField="SAG_ULASIM_SEKLI" caption="Yan ulaşım" />
                    <Column dataField="UYARI" caption="Uyarı" />
                </DataGrid>
                <Position my="center" at="center" of={window} />
            </Popup>
            {/* Child panels */}
            {!inTabMode && (
            <>
            <IslemGirPanel
                carRef={formData?.CAR_REF}
                carAdSoy={formData?.CAR_ADSOY}
                formShow={formIslemGirShow}
                refreshToken={innerRefreshToken}
                onFormKapandi={() => setFormIslemGirShow(false)}
            />
            <ResimGirPanel
                carRef={formData?.CAR_REF}
                carAdSoy={formData?.CAR_ADSOY}
                formShow={formResimGirShow}
                refreshToken={innerRefreshToken}
                onFormKapandi={() => setFormResimGirShow(false)}
            />
            <ParaGirPanel
                carRef={formData?.CAR_REF}
                carAdSoy={formData?.CAR_ADSOY}
                formShow={formParaGirShow}
                refreshToken={innerRefreshToken}
                onFormKapandi={() => setFormParaGirShow(false)}
            />
            <Carisatis
                formShow={formSatisShow}
                refreshToken={innerRefreshToken}
                ops={{ CAR_REF: formData?.CAR_REF, CAR_ADSOY: formData?.CAR_ADSOY, CAR_TEL1: formData?.CAR_TEL1, CAR_GSM: formData?.CAR_GSM, CAR_ARA_KUL_REF: formData?.CAR_ARA_KUL_REF, BENZER_VAR: formData?.BENZER_VAR, FORM_GELISLER: formData?.FORM_GELISLER }}
                onFormKapandi={() => setFormSatisShow(false)}
                onBenzerCariClick={(clickedCari) => {
                    const newOps = {
                        CAR_REF: clickedCari.CAR_REF,
                        ap: 'v',
                        ptype: 'update',
                        formReadOnly: formReadOnly,
                        crud: crud
                    };
                    getFormData(newOps);
                }}
            />
            <EkimKanalAlimGirPanel
                carRef={formData?.CAR_REF}
                carAdSoy={formData?.CAR_ADSOY}
                formShow={formEkimKanalAlimGirShow}
                refreshToken={innerRefreshToken}
                onFormKapandi={() => setFormEkimKanalAlimGirShow(false)}
            />
            </>
            )}
        </React.Fragment>
    );
}
